<div class="wizard-container" [class.read-only-mode]="isReadOnly()">
  <!-- ARIA Live Region for screen readers -->
  <div
    class="visually-hidden"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    {{ liveRegionMessage() }}
  </div>

  <!-- Instructions for accessibility -->
  @if (!isReadOnly()) {
    <div class="surface-100 border-round p-3 mb-4" role="region" aria-labelledby="form-instructions-title">
      <p id="form-instructions-title" class="text-sm text-700 m-0">
        <i class="pi pi-info-circle mr-2" aria-hidden="true"></i>
        <strong>Istruzioni:</strong> Compila tutti i campi contrassegnati con asterisco (*). La tipologia carrozzeria non può essere modificata dopo la selezione iniziale.
      </p>
    </div>
  }

  <!-- Step Content -->
  <div class="step-content">

    <!-- Tipo Carrozzeria (sempre visibile) -->
    <section class="surface-0 border-round p-4 mb-4 shadow-1">
      <div class="grid">
        <div class="field col-12">
          <label for="body-shop-type" class="font-semibold block mb-2">Tipo Carrozzeria</label>
          <input
            id="body-shop-type"
            type="text"
            pInputText
            [value]="getBodyShopTypeLabel()"
            readonly
            disabled
            class="w-full"
            [attr.aria-readonly]="true"
          />
          <small class="text-secondary block mt-2">
            <i class="pi pi-info-circle mr-1"></i>
            La tipologia è stata definita durante la registrazione e non può essere modificata.
          </small>
        </div>

      </div>
    </section>

  <!-- SEZIONE INDIRIZZO SEDE OPERATIVA (solo per sedi operative) -->
  @if (isOperationalLocation()) {
    <section class="surface-0 border-round p-5 mb-4 shadow-1" role="region" aria-labelledby="section-op-address">
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-map-marker text-2xl" style="color: #00125b;" aria-hidden="true"></i>
        <h2 id="section-op-address" class="text-xl font-semibold m-0" style="color: #00125b;">Indirizzo Sede Operativa</h2>
      </div>
      <div class="grid">
          <!-- Regione -->
          <div class="field col-12 md:col-4">
            <label for="op-region" class="font-semibold block mb-2">
              Regione <span class="text-red-500" aria-hidden="true">*</span>
            </label>
            <input id="op-region" type="text" pInputText [ngModel]="opAddressRegion()" (ngModelChange)="opAddressRegion.set($event)" placeholder="Inserisci regione" class="w-full" [disabled]="isReadOnly()" />
            @if (formSubmitted() && !opAddressRegion().trim()) {
              <small class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>
        <!-- Provincia -->
        <div class="field col-12 md:col-4">
          <label for="op-province" class="font-semibold block mb-2">
            Provincia <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <p-select
            id="op-province"
            [options]="provinceOptions()"
            [ngModel]="opAddressProvince()"
            (ngModelChange)="opAddressProvince.set($event); onOpAddressProvinceChange($event)"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleziona provincia"
            [filter]="true"
            filterBy="label"
            class="w-full"
            [disabled]="isReadOnly()"
          />
          @if (formSubmitted() && !opAddressProvince()) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <!-- Comune -->
        <div class="field col-12 md:col-4">
          <label for="op-municipality" class="font-semibold block mb-2">
            Comune <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <p-select
            id="op-municipality"
            [options]="opMunicipalityOptions()"
            [ngModel]="opAddressMunicipality()"
            (ngModelChange)="opAddressMunicipality.set($event); onOpAddressMunicipalityChange($event)"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleziona comune"
            [filter]="true"
            filterBy="label"
            class="w-full"
            [disabled]="isReadOnly() || !opAddressProvince()"
          />
          @if (formSubmitted() && !opAddressMunicipality()) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <!-- CAP -->
        <div class="field col-12 md:col-4">
          <label for="op-zipcode" class="font-semibold block mb-2">
            CAP <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <input id="op-zipcode" type="text" pInputText [ngModel]="opAddressZipCode()" (ngModelChange)="opAddressZipCode.set($event)" placeholder="00000" class="w-full" [disabled]="isReadOnly()" />
          @if (formSubmitted() && !opAddressZipCode().trim()) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <!-- Tipo Via -->
        <div class="field col-12 md:col-3">
          <label for="op-street-type" class="font-semibold block mb-2">
            Tipo Via <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <p-select
            id="op-street-type"
            [options]="streetTypeOptions()"
            [ngModel]="opAddressStreetType()"
            (ngModelChange)="opAddressStreetType.set($event)"
            optionLabel="label"
            optionValue="value"
            placeholder="-- Seleziona --"
            [filter]="true"
            [showClear]="true"
            styleClass="w-full"
            [disabled]="isReadOnly()"
          />
          @if (formSubmitted() && !opAddressStreetType().trim()) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <!-- Nome Via -->
        <div class="field col-12 md:col-6">
          <label for="op-street-name" class="font-semibold block mb-2">
            Indirizzo <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <input id="op-street-name" type="text" pInputText [ngModel]="opAddressStreetName()" (ngModelChange)="opAddressStreetName.set($event)" placeholder="Nome della via" class="w-full" [disabled]="isReadOnly()" />
          @if (formSubmitted() && !opAddressStreetName().trim()) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <!-- Civico -->
        <div class="field col-12 md:col-3">
          <label for="op-street-number" class="font-semibold block mb-2">
            Civico <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <input id="op-street-number" type="text" pInputText [ngModel]="opAddressStreetNumber()" (ngModelChange)="opAddressStreetNumber.set($event)" placeholder="es. 7 o 7/A" class="w-full" [disabled]="isReadOnly()" />
          @if (formSubmitted() && !opAddressStreetNumber()) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
      </div>
    </section>
  }

  <!-- AXA_DEUTSCHE_BANK / STANDARD-ARS-RCI-NOBIS conditional form -->
  @if (bodyShopType() === 'AXA_DEUTSCHE_BANK') {

    <!-- AXA_DEUTSCHE_BANK SECTION 3: STRUTTURA E SERVIZI -->
    <section class="surface-0 border-round p-5 mb-4 shadow-1" role="region" aria-labelledby="section-fiscali-db">
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-building text-2xl" style="color: #00125b;" aria-hidden="true"></i>
        <h2 id="section-fiscali-db" class="text-xl font-semibold m-0" style="color: #00125b;">Sezione 3: Struttura e Servizi</h2>
      </div>

      <div class="grid">
        <!-- Area Coperta -->
        <div class="field col-12 md:col-4">
          <label for="covered-area-db" class="font-semibold block mb-2">Area Coperta (metri quadri) <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="covered-area-db" [(ngModel)]="coveredArea" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 500" [disabled]="isReadOnly()" />
          @if (formSubmitted() && coveredArea() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <div class="field col-12 md:col-4">
          <label for="uncovered-area-db" class="font-semibold block mb-2">Area Scoperta (metri quadri) <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="uncovered-area-db" [(ngModel)]="uncoveredArea" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 300" [disabled]="isReadOnly()" />
          @if (formSubmitted() && uncoveredArea() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <div class="field col-12 md:col-4">
          <label for="storage-area-db" class="font-semibold block mb-2">Area Rimessaggio (metri quadri) <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="storage-area-db" [(ngModel)]="storageArea" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 200" [disabled]="isReadOnly()" />
          @if (formSubmitted() && storageArea() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Servizio Meccanica <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Servizio Meccanica">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasMechanicsServiceDb" [value]="true" [ngModel]="hasMechanicsService()" (ngModelChange)="hasMechanicsService.set($event)" inputId="has-mechanics-service-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-mechanics-service-db-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasMechanicsServiceDb" [value]="false" [ngModel]="hasMechanicsService()" (ngModelChange)="hasMechanicsService.set($event)" inputId="has-mechanics-service-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-mechanics-service-db-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>

        @if (hasMechanicsService() === true) {
        <div class="field col-12 md:col-4">
          <label for="mechanics-service-type-db" class="font-semibold block mb-2">Tipo Meccanica <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-select
            inputId="mechanics-service-type-db"
            [(ngModel)]="mechanicsServiceType"
            [options]="serviceTypeOptions()"
            optionLabel="label"
            optionValue="value"
            placeholder="Interno/Esterno"
            styleClass="w-full"
          />
        </div>
        }

        <!-- Servizio Diagnosi Elettronica -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Servizio Diagnosi Elettronica <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Servizio Diagnosi Elettronica">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasElectronicDiagnosticsDb" [value]="true" [ngModel]="hasElectronicDiagnostics()" (ngModelChange)="hasElectronicDiagnostics.set($event)" inputId="has-electronic-diagnostics-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-electronic-diagnostics-db-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasElectronicDiagnosticsDb" [value]="false" [ngModel]="hasElectronicDiagnostics()" (ngModelChange)="hasElectronicDiagnostics.set($event)" inputId="has-electronic-diagnostics-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-electronic-diagnostics-db-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>

        @if (hasElectronicDiagnostics() === true) {
        <div class="field col-12 md:col-4">
          <label for="electronic-diagnostics-type-db" class="font-semibold block mb-2">Tipo Diagnosi Elettronica <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-select
            inputId="electronic-diagnostics-type-db"
            [(ngModel)]="electronicDiagnosticsType"
            [options]="serviceTypeOptions()"
            optionLabel="label"
            optionValue="value"
            placeholder="Interno/Esterno"
            styleClass="w-full"
            [disabled]="isReadOnly()"
          />
        </div>
        }

        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Servizio Gomme <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Servizio Gomme">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasTireServiceDb" [value]="true" [ngModel]="hasTireService()" (ngModelChange)="hasTireService.set($event)" inputId="has-tire-service-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-tire-service-db-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasTireServiceDb" [value]="false" [ngModel]="hasTireService()" (ngModelChange)="hasTireService.set($event)" inputId="has-tire-service-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-tire-service-db-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>

        @if (hasTireService() === true) {
        <div class="field col-12 md:col-4">
          <label for="tire-service-type-db" class="font-semibold block mb-2">Tipo Gomme <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-select
            inputId="tire-service-type-db"
            [(ngModel)]="tireServiceType"
            [options]="serviceTypeOptions()"
            optionLabel="label"
            optionValue="value"
            placeholder="Interno/Esterno"
            styleClass="w-full"
            [disabled]="isReadOnly()"
          />
        </div>
        }

        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Ricarica Condizionatori <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Ricarica Condizionatori">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasAirConditioningRechargeDb" [value]="true" [ngModel]="hasAirConditioningRecharge()" (ngModelChange)="hasAirConditioningRecharge.set($event)" inputId="has-ac-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-ac-db-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasAirConditioningRechargeDb" [value]="false" [ngModel]="hasAirConditioningRecharge()" (ngModelChange)="hasAirConditioningRecharge.set($event)" inputId="has-ac-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-ac-db-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>

        @if (hasAirConditioningRecharge() === true) {
        <div class="field col-12 md:col-4">
          <label for="air-conditioning-recharge-type-db" class="font-semibold block mb-2">Tipo Ricarica Condizionatori <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-select
            inputId="air-conditioning-recharge-type-db"
            [(ngModel)]="airConditioningRechargeType"
            [options]="serviceTypeOptions()"
            optionLabel="label"
            optionValue="value"
            placeholder="Interno/Esterno"
            styleClass="w-full"
            [disabled]="isReadOnly()"
          />
        </div>
        }

        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Revisione Ministeriale <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Revisione Ministeriale">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasMinisterialInspectionDb" [value]="true" [ngModel]="hasMinisterialInspection()" (ngModelChange)="hasMinisterialInspection.set($event)" inputId="has-ministerial-inspection-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-ministerial-inspection-db-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasMinisterialInspectionDb" [value]="false" [ngModel]="hasMinisterialInspection()" (ngModelChange)="hasMinisterialInspection.set($event)" inputId="has-ministerial-inspection-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-ministerial-inspection-db-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>

        @if (hasMinisterialInspection() === true) {
        <div class="field col-12 md:col-4">
          <label for="ministerial-inspection-type-db" class="font-semibold block mb-2">Tipo Revisione <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-select
            inputId="ministerial-inspection-type-db"
            [(ngModel)]="ministerialInspectionType"
            [options]="serviceTypeOptions()"
            optionLabel="label"
            optionValue="value"
            placeholder="Interno/Esterno"
            styleClass="w-full"
            [disabled]="isReadOnly()"
          />
        </div>
        }
      </div>
    </section>

    <!-- AXA_DEUTSCHE_BANK SECTION 4: TIPOLOGIA RIPARAZIONI -->
    <section class="surface-0 border-round p-5 mb-4 shadow-1" role="region" aria-labelledby="section-riparazioni-db">
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-cog text-2xl" style="color: #00125b;" aria-hidden="true"></i>
        <h2 id="section-riparazioni-db" class="text-xl font-semibold m-0" style="color: #00125b;">Sezione 4: Tipologia Riparazioni</h2>
      </div>

      <div class="grid">
        <!-- Cristalli Riparazione -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Cristalli Riparazione <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Cristalli Riparazione">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasWindshieldRepairDb" [value]="true" [ngModel]="hasWindshieldRepair()" (ngModelChange)="hasWindshieldRepair.set($event)" inputId="has-windshield-repair-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-windshield-repair-db-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasWindshieldRepairDb" [value]="false" [ngModel]="hasWindshieldRepair()" (ngModelChange)="hasWindshieldRepair.set($event)" inputId="has-windshield-repair-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-windshield-repair-db-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>

        <!-- Cristalli Sostituzione (AXA_DEUTSCHE_BANK only) -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Cristalli Sostituzione <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Cristalli Sostituzione">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasWindshieldReplacement" [value]="true" [ngModel]="hasWindshieldReplacement()" (ngModelChange)="hasWindshieldReplacement.set($event)" inputId="has-windshield-replacement-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-windshield-replacement-db-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasWindshieldReplacement" [value]="false" [ngModel]="hasWindshieldReplacement()" (ngModelChange)="hasWindshieldReplacement.set($event)" inputId="has-windshield-replacement-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-windshield-replacement-db-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>

        <!-- Motoveicoli / Ciclomotori (AXA_DEUTSCHE_BANK only) -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Motoveicoli / Ciclomotori <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Motoveicoli / Ciclomotori">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasMotorcycleRepair" [value]="true" [ngModel]="hasMotorcycleRepair()" (ngModelChange)="hasMotorcycleRepair.set($event)" inputId="has-motorcycle-repair-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-motorcycle-repair-db-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasMotorcycleRepair" [value]="false" [ngModel]="hasMotorcycleRepair()" (ngModelChange)="hasMotorcycleRepair.set($event)" inputId="has-motorcycle-repair-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-motorcycle-repair-db-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Interventi smart <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Interventi smart">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSmartServicesDb" [value]="true" [ngModel]="hasSmartServices()" (ngModelChange)="hasSmartServices.set($event)" inputId="has-smart-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-smart-db-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSmartServicesDb" [value]="false" [ngModel]="hasSmartServices()" (ngModelChange)="hasSmartServices.set($event)" inputId="has-smart-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-smart-db-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Riparazioni Spot <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Riparazioni Spot">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSpotRepairsDb" [value]="true" [ngModel]="hasSpotRepairs()" (ngModelChange)="hasSpotRepairs.set($event)" inputId="has-spot-repairs-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-spot-repairs-db-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSpotRepairsDb" [value]="false" [ngModel]="hasSpotRepairs()" (ngModelChange)="hasSpotRepairs.set($event)" inputId="has-spot-repairs-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-spot-repairs-db-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="border-1 border-200 border-round p-3">
            <p class="font-semibold text-sm text-600 mt-0 mb-3">Veicoli Particolari</p>
            <div class="grid">
              <div class="field col-12 md:col-4">
                <div class="font-semibold block mb-2">Riparazioni Veicoli Particolari <span class="text-red-500" aria-hidden="true">*</span></div>
                <div class="flex gap-3" role="group" aria-label="Riparazioni Veicoli Particolari">
                  <div class="flex align-items-center gap-2">
                    <p-radiobutton name="hasSpecialVehicleRepairsDb" [value]="true" [ngModel]="hasSpecialVehicleRepairs()" (ngModelChange)="hasSpecialVehicleRepairs.set($event)" inputId="has-special-vehicles-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                    <label for="has-special-vehicles-db-si" class="cursor-pointer">Sì</label>
                  </div>
                  <div class="flex align-items-center gap-2">
                    <p-radiobutton name="hasSpecialVehicleRepairsDb" [value]="false" [ngModel]="hasSpecialVehicleRepairs()" (ngModelChange)="hasSpecialVehicleRepairs.set($event)" inputId="has-special-vehicles-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
                    <label for="has-special-vehicles-db-no" class="cursor-pointer">No</label>
                  </div>
                </div>
              </div>

              @if (hasSpecialVehicleRepairs()) {
              <div class="field col-12">
                <div class="flex align-items-center justify-content-between mb-2">
                  <label class="font-semibold">Tipologie Veicoli Particolari</label>
                  @if (!isReadOnly()) {
                    <button type="button" pButton label="Aggiungi" icon="pi pi-plus" class="p-button-sm p-button-outlined add-item-btn" aria-label="Aggiungi tipologia veicolo" (click)="addSpecialVehicle()"></button>
                  }
                </div>
                @if (specialVehicles().length === 0) {
                  <p class="text-secondary m-0">Nessuna tipologia aggiunta.</p>
                  @if (formSubmitted()) {
                    <small class="text-red-500" role="alert">Aggiungere almeno una tipologia di veicolo</small>
                  }
                }
                @for (vehicle of specialVehicles(); track vehicle.id; let idx = $index) {
                  <div class="card bg-gray-50 mb-2 p-3">
                    <div class="flex align-items-center justify-content-between mb-2">
                      <label [attr.for]="'vehicle-type-db-' + vehicle.id" class="font-semibold">Tipologia Veicolo {{ idx + 1 }}</label>
                      @if (!isReadOnly()) {
                        <button type="button" pButton icon="pi pi-trash" class="p-button-sm p-button-danger p-button-text" (click)="removeSpecialVehicle(vehicle.id)" aria-label="Rimuovi veicolo"></button>
                      }
                    </div>
                    <div class="grid">
                      <div class="field col-12 md:col-4">
                        <p-select [inputId]="'vehicle-type-db-' + vehicle.id" [(ngModel)]="vehicle.vehicleType" [options]="getAvailableSpecialVehicleOptions(vehicle.id)" optionLabel="label" optionValue="value" placeholder="Seleziona" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                      </div>
                      @if (vehicle.vehicleType === 'OTHER') {
                        <div class="field col-12 md:col-4">
                          <label [attr.for]="'vehicle-other-db-' + vehicle.id" class="font-semibold block mb-2">Specifica <span class="text-red-500" aria-hidden="true">*</span></label>
                          <input [attr.id]="'vehicle-other-db-' + vehicle.id" type="text" pInputText [(ngModel)]="vehicle.vehicleTypeOther" placeholder="Tipo veicolo..." class="w-full" [disabled]="isReadOnly()" />
                          @if (formSubmitted() && !vehicle.vehicleTypeOther.trim()) {
                            <small class="text-red-500" role="alert">Campo obbligatorio</small>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
              }
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Auto Sostitutiva <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Auto Sostitutiva">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSubstituteCarDb" [value]="true" [ngModel]="hasSubstituteCar()" (ngModelChange)="hasSubstituteCar.set($event)" inputId="has-substitute-car-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-substitute-car-db-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSubstituteCarDb" [value]="false" [ngModel]="hasSubstituteCar()" (ngModelChange)="hasSubstituteCar.set($event)" inputId="has-substitute-car-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-substitute-car-db-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Soccorso Stradale entro 20km <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Soccorso Stradale entro 20km">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasRoadsideAssistance20kmDb" [value]="true" [ngModel]="hasRoadsideAssistance20km()" (ngModelChange)="hasRoadsideAssistance20km.set($event)" inputId="has-roadside-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-roadside-db-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasRoadsideAssistance20kmDb" [value]="false" [ngModel]="hasRoadsideAssistance20km()" (ngModelChange)="hasRoadsideAssistance20km.set($event)" inputId="has-roadside-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-roadside-db-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Pick up &amp; Delivery - servizio presa e riconsegna veicolo a domicilio entro 20km <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Pick up & Delivery entro 20km">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasPickupDelivery20kmDb" [value]="true" [ngModel]="hasPickupDelivery20km()" (ngModelChange)="hasPickupDelivery20km.set($event)" inputId="has-pickup-db-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-pickup-db-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasPickupDelivery20kmDb" [value]="false" [ngModel]="hasPickupDelivery20km()" (ngModelChange)="hasPickupDelivery20km.set($event)" inputId="has-pickup-db-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-pickup-db-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- AXA_DEUTSCHE_BANK SECTION 5: ORGANIZZAZIONE -->
    <section class="surface-0 border-round p-5 mb-4 shadow-1" role="region" aria-labelledby="section-conflitto-db">
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-users text-2xl" style="color: #00125b;" aria-hidden="true"></i>
        <h2 id="section-conflitto-db" class="text-xl font-semibold m-0" style="color: #00125b;">Sezione 5: Organizzazione</h2>
      </div>

      <div class="grid">
        <div class="col-12">
          <div class="border-1 border-200 border-round p-3">
            <p class="font-semibold text-sm text-600 mt-0 mb-3">Carrozzeria Autorizzata Casa Automobilistica</p>
            <div class="flex align-items-center justify-content-between mb-2">
              <span></span>
              @if (!isReadOnly()) {
                <button type="button" pButton label="Aggiungi" icon="pi pi-plus" class="p-button-sm p-button-outlined add-item-btn" aria-label="Aggiungi casa automobilistica" (click)="addAuthorization()"></button>
              }
            </div>
            @if (authorizations().length === 0) {
              <p class="text-secondary m-0">Nessuna casa automobilistica aggiunta.</p>
            }
            @for (auth of authorizations(); track auth.id; let idx = $index) {
              <div class="card bg-gray-50 mb-2 p-3">
                <div class="flex align-items-center justify-content-between mb-2">
                  <label [attr.for]="'car-man-db-' + auth.id" class="font-semibold">Casa Automobilistica {{ idx + 1 }}</label>
                  @if (!isReadOnly()) {
                    <button type="button" pButton icon="pi pi-trash" class="p-button-sm p-button-danger p-button-text" (click)="removeAuthorization(auth.id)" aria-label="Rimuovi casa automobilistica"></button>
                  }
                </div>
                <div class="grid">
                  <div class="field col-12 md:col-4">
                    <p-select [inputId]="'car-man-db-' + auth.id" [(ngModel)]="auth.carManufacturer" [options]="getAvailableCarManufacturerOptions(auth.id)" optionLabel="label" optionValue="value" placeholder="Seleziona" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                  </div>
                  @if (auth.carManufacturer === 'OTHER') {
                    <div class="field col-12 md:col-4">
                      <label [attr.for]="'car-man-other-db-' + auth.id" class="font-semibold block mb-2">Specifica <span class="text-red-500" aria-hidden="true">*</span></label>
                      <input [attr.id]="'car-man-other-db-' + auth.id" type="text" pInputText [(ngModel)]="auth.carManufacturerOther" placeholder="Casa automobilistica..." class="w-full" [disabled]="isReadOnly()" />
                      @if (formSubmitted() && !auth.carManufacturerOther.trim()) {
                        <small class="text-red-500" role="alert">Campo obbligatorio</small>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label for="employees-count-db" class="font-semibold block mb-2">N° Dipendenti inseriti a Libro Matricola <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="employees-count-db" [(ngModel)]="employeesCount" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 15" [disabled]="isReadOnly()" />
          @if (formSubmitted() && employeesCount() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
      </div>
    </section>

  } @else {

    <!-- STANDARD/ARS/RCI/NOBIS Form - 6 Sezioni -->

    <!-- SEZIONE 1: INFORMAZIONI STRUTTURA E ATTREZZATURE -->
    <section class="surface-0 border-round p-5 mb-4 shadow-1" role="region" aria-labelledby="section-struttura">
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-building text-2xl" style="color: #00125b;" aria-hidden="true"></i>
        <h2 id="section-struttura" class="text-xl font-semibold m-0" style="color: #00125b;">Sezione 1: Informazioni Struttura e Attrezzature</h2>
      </div>

      <div class="grid">
        <!-- Presenza Web: SI/NO + "Se sì, come?" inline a destra -->
        <div class="col-12">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="field flex-none" style="min-width: 260px;">
              <div class="font-semibold block mb-2">
                L'azienda è presente sul web? <span class="text-red-500" aria-hidden="true">*</span>
                <span class="visually-hidden">obbligatorio</span>
              </div>
              <div class="flex gap-3" role="group" aria-label="L'azienda è presente sul web?"
                [attr.aria-invalid]="(formSubmitted() || touchedFields.has('isPresentOnline')) && isPresentOnline() === null"
                [attr.aria-describedby]="(formSubmitted() || touchedFields.has('isPresentOnline')) && isPresentOnline() === null ? 'has-web-presence-error' : null">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton
                    name="isPresentOnline"
                    [value]="true"
                    [ngModel]="isPresentOnline()"
                    (ngModelChange)="isPresentOnline.set($event)"
                    inputId="has-web-presence-si"
                    (blur)="markFieldAsTouched('isPresentOnline')"
                    [disabled]="isReadOnly()"
                    [attr.aria-required]="true"
                    ariaLabel="Sì, l'azienda è presente sul web"
                  />
                  <label for="has-web-presence-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton
                    name="isPresentOnline"
                    [value]="false"
                    [ngModel]="isPresentOnline()"
                    (ngModelChange)="isPresentOnline.set($event)"
                    inputId="has-web-presence-no"
                    (blur)="markFieldAsTouched('isPresentOnline')"
                    [disabled]="isReadOnly()"
                    [attr.aria-required]="true"
                    ariaLabel="No, l'azienda non è presente sul web"
                  />
                  <label for="has-web-presence-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if ((formSubmitted() || touchedFields.has('isPresentOnline')) && isPresentOnline() === null) {
                <small id="has-web-presence-error" class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (isPresentOnline() === true) {
              <div class="field flex-none" style="min-width: 220px;">
                <label for="web-presence-type" class="font-semibold block mb-2">Se sì, come? <span class="text-red-500" aria-hidden="true">*</span></label>
                <p-select
                  inputId="web-presence-type"
                  [(ngModel)]="typePresenceOnline"
                  [options]="webPresenceTypeOptions()"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Seleziona tipo"
                  styleClass="w-full"
                  [disabled]="isReadOnly()"
                  (onChange)="markFieldAsTouched('typePresenceOnline')"
                />
                @if ((formSubmitted() || touchedFields.has('typePresenceOnline')) && !typePresenceOnline()) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- URL sito web (solo se WEBSITE) -->
        @if (typePresenceOnline() === 'WEBSITE') {
          <div class="field col-12">
            <label for="web-presence-url" class="font-semibold block mb-2">Denominazione sito web <span class="text-red-500" aria-hidden="true">*</span></label>
            <input
              id="web-presence-url"
              type="text"
              pInputText
              [(ngModel)]="webPresenceUrl"
              placeholder="Es. www.nomecarrozzeria.it"
              class="w-full"
              [disabled]="isReadOnly()"
              (blur)="markFieldAsTouched('webPresenceUrl')"
            />
            @if ((formSubmitted() || touchedFields.has('webPresenceUrl')) && !webPresenceUrl().trim()) {
              <small class="text-red-500" role="alert">Inserire la denominazione del sito web</small>
            }
          </div>
        }
        <!-- Testo libero (solo se OTHER) -->
        @if (typePresenceOnline() === 'OTHER') {
          <div class="field col-12">
            <label for="web-presence-other" class="font-semibold block mb-2">Specifica <span class="text-red-500" aria-hidden="true">*</span></label>
            <input
              id="web-presence-other"
              type="text"
              pInputText
              [(ngModel)]="otherOnlinePresence"
              placeholder="Specificare tipo di presenza web"
              class="w-full"
              [disabled]="isReadOnly()"
              (blur)="markFieldAsTouched('otherOnlinePresence')"
            />
            @if ((formSubmitted() || touchedFields.has('otherOnlinePresence')) && !otherOnlinePresence().trim()) {
              <small class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>
        }

        <!-- Google My Business -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">
            L'azienda gestisce i contenuti di Google my Business? <span class="text-red-500" aria-hidden="true">*</span>
            <span class="visually-hidden">obbligatorio</span>
          </div>
          <div class="flex gap-3" role="group" aria-label="L'azienda gestisce i contenuti di Google my Business?"
            [attr.aria-invalid]="(formSubmitted() || touchedFields.has('manageGoogleMyBusiness')) && manageGoogleMyBusiness() === null"
            [attr.aria-describedby]="(formSubmitted() || touchedFields.has('manageGoogleMyBusiness')) && manageGoogleMyBusiness() === null ? 'has-gmb-error' : null">
            <div class="flex align-items-center gap-2">
              <p-radiobutton
                name="manageGoogleMyBusiness"
                [value]="true"
                [ngModel]="manageGoogleMyBusiness()"
                (ngModelChange)="manageGoogleMyBusiness.set($event)"
                inputId="has-gmb-si"
                (blur)="markFieldAsTouched('manageGoogleMyBusiness')"
                [disabled]="isReadOnly()"
                ariaLabel="Sì"
              />
              <label for="has-gmb-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton
                name="manageGoogleMyBusiness"
                [value]="false"
                [ngModel]="manageGoogleMyBusiness()"
                (ngModelChange)="manageGoogleMyBusiness.set($event)"
                inputId="has-gmb-no"
                (blur)="markFieldAsTouched('manageGoogleMyBusiness')"
                [disabled]="isReadOnly()"
                ariaLabel="No"
              />
              <label for="has-gmb-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if ((formSubmitted() || touchedFields.has('manageGoogleMyBusiness')) && manageGoogleMyBusiness() === null) {
            <small id="has-gmb-error" class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- Orari di apertura  3  col-4 = 12 S -->
        <div class="field col-12 md:col-4">
          <label for="morning-opening" class="font-semibold block mb-2">
            Orario Apertura Mattina <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <input id="morning-opening" type="text" pInputText [(ngModel)]="morningOpeningHours" placeholder="Es: 08:30-12:30" class="w-full" [disabled]="isReadOnly()" (blur)="markFieldAsTouched('morningOpeningHours')" aria-required="true" aria-describedby="morning-opening-error" />
          @if ((formSubmitted() || touchedFields.has('morningOpeningHours')) && !hasMeaningfulText(morningOpeningHours())) {
            <small id="morning-opening-error" class="text-red-500" role="alert">Campo obbligatorio</small>
          }
          @if ((formSubmitted() || touchedFields.has('morningOpeningHours')) && morningOpeningHours() && !isValidTimeRange(morningOpeningHours())) {
            <small id="morning-opening-error" class="text-red-500" role="alert">Formato non valido - usa HH:MM-HH:MM (es: 08:30-12:30)</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <label for="afternoon-opening" class="font-semibold block mb-2">
            Orario Apertura Pomeriggio <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <input id="afternoon-opening" type="text" pInputText [(ngModel)]="afternoonOpeningHours" placeholder="Es: 14:00-18:00" class="w-full" [disabled]="isReadOnly()" (blur)="markFieldAsTouched('afternoonOpeningHours')" aria-required="true" aria-describedby="afternoon-opening-error" />
          @if ((formSubmitted() || touchedFields.has('afternoonOpeningHours')) && !hasMeaningfulText(afternoonOpeningHours())) {
            <small id="afternoon-opening-error" class="text-red-500" role="alert">Campo obbligatorio</small>
          }
          @if ((formSubmitted() || touchedFields.has('afternoonOpeningHours')) && afternoonOpeningHours() && !isValidTimeRange(afternoonOpeningHours())) {
            <small id="afternoon-opening-error" class="text-red-500" role="alert">Formato non valido - usa HH:MM-HH:MM (es: 14:00-18:00)</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <label for="saturday-opening" class="font-semibold block mb-2">
            Orario Apertura Sabato <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <input id="saturday-opening" type="text" pInputText [(ngModel)]="saturdayOpeningHours" placeholder="Es: 08:30-12:30" class="w-full" [disabled]="isReadOnly()" (blur)="markFieldAsTouched('saturdayOpeningHours')" aria-required="true" aria-describedby="saturday-opening-error" />
          @if ((formSubmitted() || touchedFields.has('saturdayOpeningHours')) && !hasMeaningfulText(saturdayOpeningHours())) {
            <small id="saturday-opening-error" class="text-red-500" role="alert">Campo obbligatorio</small>
          }
          @if ((formSubmitted() || touchedFields.has('saturdayOpeningHours')) && saturdayOpeningHours() && !isValidTimeRange(saturdayOpeningHours())) {
            <small id="saturday-opening-error" class="text-red-500" role="alert">Formato non valido - usa HH:MM-HH:MM (es: 08:30-12:30)</small>
          }
        </div>

        <!-- Aree -->
        <div class="field col-12 md:col-4">
          <label for="covered-area" class="font-semibold block mb-2">Area Coperta (metri quadri) <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="covered-area" [(ngModel)]="coveredArea" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 500" (onBlur)="markFieldAsTouched('coveredArea')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
          @if ((formSubmitted() || touchedFields.has('coveredArea')) && coveredArea() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <label for="uncovered-area" class="font-semibold block mb-2">Area Scoperta (metri quadri) <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="uncovered-area" [(ngModel)]="uncoveredArea" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 300" (onBlur)="markFieldAsTouched('uncoveredArea')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
          @if ((formSubmitted() || touchedFields.has('uncoveredArea')) && uncoveredArea() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <label for="storage-area" class="font-semibold block mb-2">Area Rimessaggio (metri quadri) <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="storage-area" [(ngModel)]="storageArea" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 200" (onBlur)="markFieldAsTouched('storageArea')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
          @if ((formSubmitted() || touchedFields.has('storageArea')) && storageArea() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <label for="customer-reception-area" class="font-semibold block mb-2">Area Accoglienza Clienti (metri quadri) <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="customer-reception-area" [(ngModel)]="customerReceptionArea" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 50" (onBlur)="markFieldAsTouched('customerReceptionArea')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
          @if ((formSubmitted() || touchedFields.has('customerReceptionArea')) && customerReceptionArea() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- Accesso disabili / Parcheggio clienti -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Accessi riservati a diversamente abili (SI/NO)?</div>
          <div class="flex gap-3" role="group" aria-label="Accessi riservati a diversamente abili (SI/NO)">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasAccessForDisabledPeople" [value]="true" [ngModel]="hasAccessForDisabledPeople()" (ngModelChange)="hasAccessForDisabledPeople.set($event)" inputId="has-disabled-access-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-disabled-access-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasAccessForDisabledPeople" [value]="false" [ngModel]="hasAccessForDisabledPeople()" (ngModelChange)="hasAccessForDisabledPeople.set($event)" inputId="has-disabled-access-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-disabled-access-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Disponibile un parcheggio riservato ai clienti (SI/NO)?</div>
          <div class="flex gap-3" role="group" aria-label="Disponibile un parcheggio riservato ai clienti (SI/NO)">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasCustomerParking" [value]="true" [ngModel]="hasCustomerParking()" (ngModelChange)="hasCustomerParking.set($event)" inputId="has-customer-parking-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-customer-parking-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasCustomerParking" [value]="false" [ngModel]="hasCustomerParking()" (ngModelChange)="hasCustomerParking.set($event)" inputId="has-customer-parking-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-customer-parking-no" class="cursor-pointer">No</label>
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-8">
          <label for="operating-territories" class="font-semibold block mb-2">Territorio operativo</label>
          <p-multiselect
            id="operating-territories"
            [ngModel]="operatingTerritories()"
            (ngModelChange)="operatingTerritories.set($event)"
            [options]="provinceOptions()"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleziona Provincia"
            [filter]="true"
            [showToggleAll]="true"
            [showClear]="true"
            display="chip"
            [maxSelectedLabels]="provinceOptions().length"
            styleClass="w-full"
            [disabled]="isReadOnly()"
          />
        </div>
      </div>

      <!-- Attrezzature subsection -->
      <div class="mt-4 pt-3 border-top-1 border-200">
        <h3 class="text-lg font-semibold mb-3" style="color: #00125b;">Attrezzature</h3>
        <div class="grid">
          <!-- Forni verniciatura -->
          <div class="field col-12 md:col-4">
            <label for="paint-booths-count" class="font-semibold block mb-2">N° Forno Cabine <span class="text-red-500" aria-hidden="true">*</span></label>
            <p-inputNumber inputId="paint-booths-count" [(ngModel)]="paintBoothsCount" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 2" (onBlur)="markFieldAsTouched('paintBoothsCount')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
            @if ((formSubmitted() || touchedFields.has('paintBoothsCount')) && paintBoothsCount() == null) {
              <small class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>
          <div class="field col-12 md:col-4">
            <label for="paint-booths-year" class="font-semibold block mb-2">Ultimo Anno Installazione Forno Cabine <span class="text-red-500" aria-hidden="true">*</span></label>
            <p-inputNumber inputId="paint-booths-year" [(ngModel)]="paintBoothsInstallationYear" [min]="1900" [max]="2100" [useGrouping]="false" [showButtons]="false" styleClass="w-full" placeholder="Es: 2020" (onBlur)="markFieldAsTouched('paintBoothsInstallationYear')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
            @if ((formSubmitted() || touchedFields.has('paintBoothsInstallationYear')) && paintBoothsInstallationYear() == null) {
              <small class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>


          <!-- Vernice e tipo essicazione -->
          <div class="field col-12 md:col-4">
            <label for="paint-brand" class="font-semibold block mb-2">Vernice Marca Utilizzata <span class="text-red-500" aria-hidden="true">*</span></label>
            <input id="paint-brand" type="text" pInputText [(ngModel)]="paintBrand" placeholder="Es: PPG, Sikkens..." class="w-full" [disabled]="isReadOnly()" (blur)="markFieldAsTouched('paintBrand')" aria-required="true" aria-describedby="paint-brand-error" />
            @if ((formSubmitted() || touchedFields.has('paintBrand')) && !hasMeaningfulText(paintBrand())) {
              <small id="paint-brand-error" class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>
          <div class="field col-12 md:col-4">
            <label for="drying-type" class="font-semibold block mb-2">Tipo Essicazione <span class="text-red-500" aria-hidden="true">*</span></label>
            <p-select inputId="drying-type" [(ngModel)]="dryingType" [options]="dryingTypeOptions()" optionLabel="label" optionValue="value" placeholder="Seleziona tipo essicazione" styleClass="w-full" (onChange)="markFieldAsTouched('dryingType')" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
            @if ((formSubmitted() || touchedFields.has('dryingType')) && !dryingType()) {
              <small class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>
          @if (dryingType() === 'OTHER') {
            <div class="field col-12 md:col-4">
              <label for="drying-type-other" class="font-semibold block mb-2">Specifica Tipo Essicazione <span class="text-red-500" aria-hidden="true">*</span></label>
              <input id="drying-type-other" type="text" pInputText [(ngModel)]="dryingTypeOther" placeholder="Specifica..." class="w-full" [disabled]="isReadOnly()" aria-required="true" aria-describedby="drying-type-other-error" />
              @if (formSubmitted() && !dryingTypeOther().trim()) {
                <small id="drying-type-other-error" class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
          }

          <!-- Tintometro e alluminio -->
          <div class="field col-12 md:col-4">
            <div class="font-semibold block mb-2">Tintometro <span class="text-red-500" aria-hidden="true">*</span></div>
            <div class="flex gap-3" role="group" aria-label="Tintometro">
              <div class="flex align-items-center gap-2">
                <p-radiobutton name="isPresentTinometer" [value]="true" [ngModel]="isPresentTinometer()" (ngModelChange)="isPresentTinometer.set($event)" inputId="has-tintometer-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                <label for="has-tintometer-si" class="cursor-pointer">Sì</label>
              </div>
              <div class="flex align-items-center gap-2">
                <p-radiobutton name="isPresentTinometer" [value]="false" [ngModel]="isPresentTinometer()" (ngModelChange)="isPresentTinometer.set($event)" inputId="has-tintometer-no" [disabled]="isReadOnly()" ariaLabel="No" />
                <label for="has-tintometer-no" class="cursor-pointer">No</label>
              </div>
            </div>
            @if (formSubmitted() && isPresentTinometer() === null) {
              <small class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>
          <div class="field col-12 md:col-4">
            <div class="font-semibold block mb-2">Interventi Alluminio <span class="text-red-500" aria-hidden="true">*</span></div>
            <div class="flex gap-3" role="group" aria-label="Interventi Alluminio">
              <div class="flex align-items-center gap-2">
                <p-radiobutton name="aluminumWork" [value]="true" [ngModel]="aluminumWork()" (ngModelChange)="aluminumWork.set($event)" inputId="aluminum-work-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                <label for="aluminum-work-si" class="cursor-pointer">Sì</label>
              </div>
              <div class="flex align-items-center gap-2">
                <p-radiobutton name="aluminumWork" [value]="false" [ngModel]="aluminumWork()" (ngModelChange)="aluminumWork.set($event)" inputId="aluminum-work-no" [disabled]="isReadOnly()" ariaLabel="No" />
                <label for="aluminum-work-no" class="cursor-pointer">No</label>
              </div>
            </div>
            @if (formSubmitted() && aluminumWork() === null) {
              <small class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>

          <!-- Attrezzature specifiche -->
          <div class="field col-12">
            <label for="specific-equipment" class="font-semibold block mb-2">Attrezzature Specifiche</label>
            <input id="specific-equipment" type="text" pInputText [(ngModel)]="specificEquipment" placeholder="Descrizione libera" class="w-full" [disabled]="isReadOnly()" />
          </div>

          <!-- Ponti sollevatori  gruppo -->
          <div class="col-12">
            <div class="border-1 border-200 border-round p-3">
              <p class="font-semibold text-sm text-600 mt-0 mb-3">Ponti Sollevatori</p>
              <div class="grid">

                <!-- N° Ponti sollevatori -->
                <div class="field col-12 md:col-4">
                  <label for="lifts-count" class="font-semibold block mb-2">N° Ponti Sollevatori <span class="text-red-500" aria-hidden="true">*</span></label>
                  <p-inputNumber inputId="lifts-count" [(ngModel)]="liftsCount" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 4" (onBlur)="markFieldAsTouched('liftsCount')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
                  @if ((formSubmitted() || touchedFields.has('liftsCount')) && liftsCount() == null) {
                    <small class="text-red-500" role="alert">Campo obbligatorio</small>
                  }
                  @if (liftsCount() != null && liftsCount() !== bridges().length) {
                    <small class="text-orange-500" role="alert">
                      Hai indicato {{ liftsCount() }} ponti ma ne hai configurati {{ bridges().length }}.
                    </small>
                  }
                </div>

                <!-- Ponti (ripetibile) -->
                <div class="field col-12">
                  <div class="flex align-items-center justify-content-between mb-2">
                    <label class="font-semibold">Tipi di Ponte</label>
                    @if (!isReadOnly()) {
                      <button type="button" pButton label="Aggiungi Ponte" icon="pi pi-plus" class="p-button-sm p-button-outlined add-item-btn" aria-label="Aggiungi Ponte" (click)="addBridge()"></button>
                    }
                  </div>
                  @if (bridges().length === 0) {
                    <p class="text-secondary m-0">Nessun ponte aggiunto.</p>
                    @if ((formSubmitted() || touchedFields.has('bridges')) && (liftsCount() ?? 0) > 0) {
                      <small class="text-red-500" role="alert">Aggiungere almeno un tipo di ponte</small>
                    }
                  }
                  @for (bridge of bridges(); track bridge.id; let idx = $index) {
                    <div class="card bg-gray-50 mb-2 p-3">
                      <div class="flex align-items-center justify-content-between mb-2">
                        <label [attr.for]="'bridge-type-' + bridge.id" class="font-semibold">Tipo Ponte {{ idx + 1 }}</label>
                        @if (!isReadOnly()) {
                          <button type="button" pButton icon="pi pi-trash" class="p-button-sm p-button-danger p-button-text" (click)="removeBridge(bridge.id)" aria-label="Rimuovi ponte"></button>
                        }
                      </div>
                      <div class="grid">
                        <div class="field col-12 md:col-4">
                          <p-select [inputId]="'bridge-type-' + bridge.id" [(ngModel)]="bridge.bridgeType" [options]="liftTypeOptions()" optionLabel="label" optionValue="value" placeholder="Seleziona tipo ponte" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                        </div>
                        @if (bridge.bridgeType === 'OTHER') {
                          <div class="field col-12 md:col-4">
                            <label [attr.for]="'bridge-other-' + bridge.id" class="font-semibold block mb-2">Specifica <span class="text-red-500" aria-hidden="true">*</span></label>
                            <input [attr.id]="'bridge-other-' + bridge.id" type="text" pInputText [(ngModel)]="bridge.bridgeTypeOther" placeholder="Tipo ponte..." class="w-full" [disabled]="isReadOnly()" />
                            @if (formSubmitted() && !bridge.bridgeTypeOther.trim()) {
                              <small class="text-red-500" role="alert">Campo obbligatorio</small>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>

              </div>
            </div>
          </div>

          <!-- Riga: Dima | Misurazione Digitale Scocche  2col-4 (+ col-4 vuoto)   meglio col-4 + col-4 fissi -->
          <div class="field col-12 md:col-4">
            <div class="font-semibold block mb-2">Dima <span class="text-red-500" aria-hidden="true">*</span></div>
            <div class="flex gap-3" role="group" aria-label="Dima">
              <div class="flex align-items-center gap-2">
                <p-radiobutton name="hasJig" [value]="true" [ngModel]="hasJig()" (ngModelChange)="hasJig.set($event)" inputId="has-jig-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                <label for="has-jig-si" class="cursor-pointer">Sì</label>
              </div>
              <div class="flex align-items-center gap-2">
                <p-radiobutton name="hasJig" [value]="false" [ngModel]="hasJig()" (ngModelChange)="hasJig.set($event)" inputId="has-jig-no" [disabled]="isReadOnly()" ariaLabel="No" />
                <label for="has-jig-no" class="cursor-pointer">No</label>
              </div>
            </div>
            @if ((formSubmitted() || touchedFields.has('hasJig')) && hasJig() === null) {
              <small class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>

          @if (hasJig() === true) {
            <div class="field col-12 md:col-4">
              <label for="jig-type" class="font-semibold block mb-2">Tipo Dima <span class="text-red-500" aria-hidden="true">*</span></label>
              <p-select inputId="jig-type" [(ngModel)]="jigType" [options]="jigTypeOptions()" optionLabel="label" optionValue="value" placeholder="Seleziona" styleClass="w-full" [disabled]="isReadOnly()" (onChange)="markFieldAsTouched('jigType')" [pt]="{ root: { 'aria-required': 'true' } }" />
              @if ((formSubmitted() || touchedFields.has('jigType')) && !jigType()) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (jigType() === 'OTHER') {
              <div class="field col-12 md:col-4">
                <label for="jig-type-other" class="font-semibold block mb-2">Specifica Tipo Dima <span class="text-red-500" aria-hidden="true">*</span></label>
                <input id="jig-type-other" type="text" pInputText [(ngModel)]="jigTypeOther" placeholder="Tipo dima..." class="w-full" [disabled]="isReadOnly()" aria-required="true" aria-describedby="jig-type-other-error" />
                @if (formSubmitted() && !jigTypeOther().trim()) {
                  <small id="jig-type-other-error" class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          }

          <div class="field col-12 md:col-4">
            <div class="font-semibold block mb-2">Misurazione Digitale Scocche <span class="text-red-500" aria-hidden="true">*</span></div>
            <div class="flex gap-3" role="group" aria-label="Misurazione Digitale Scocche">
              <div class="flex align-items-center gap-2">
                <p-radiobutton name="hasDigitalMeasurement" [value]="true" [ngModel]="hasDigitalMeasurement()" (ngModelChange)="hasDigitalMeasurement.set($event)" inputId="has-digital-measurement-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                <label for="has-digital-measurement-si" class="cursor-pointer">Sì</label>
              </div>
              <div class="flex align-items-center gap-2">
                <p-radiobutton name="hasDigitalMeasurement" [value]="false" [ngModel]="hasDigitalMeasurement()" (ngModelChange)="hasDigitalMeasurement.set($event)" inputId="has-digital-measurement-no" [disabled]="isReadOnly()" ariaLabel="No" />
                <label for="has-digital-measurement-no" class="cursor-pointer">No</label>
              </div>
            </div>
            @if ((formSubmitted() || touchedFields.has('hasDigitalMeasurement')) && hasDigitalMeasurement() === null) {
              <small class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>

          @if (hasDigitalMeasurement() === true) {
            <div class="field col-12 md:col-4">
              <label for="digital-measurement-type" class="font-semibold block mb-2">Tipo Misurazione Digitale <span class="text-red-500" aria-hidden="true">*</span></label>
              <p-select inputId="digital-measurement-type" [(ngModel)]="digitalMeasurementType" [options]="digitalMeasurementTypeOptions()" optionLabel="label" optionValue="value" placeholder="Seleziona" styleClass="w-full" [disabled]="isReadOnly()" (onChange)="markFieldAsTouched('digitalMeasurementType')" [pt]="{ root: { 'aria-required': 'true' } }" />
              @if ((formSubmitted() || touchedFields.has('digitalMeasurementType')) && !digitalMeasurementType()) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (digitalMeasurementType() === 'OTHER') {
              <div class="field col-12 md:col-4">
                <label for="digital-measurement-other" class="font-semibold block mb-2">Specifica Tipo Misurazione <span class="text-red-500" aria-hidden="true">*</span></label>
                <input id="digital-measurement-other" type="text" pInputText [(ngModel)]="otherDigitalMeasurement" placeholder="Tipo misurazione..." class="w-full" [disabled]="isReadOnly()" aria-required="true" aria-describedby="digital-measurement-other-error" />
                @if (formSubmitted() && !otherDigitalMeasurement().trim()) {
                  <small id="digital-measurement-other-error" class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          }

          <!-- Polveri -->
          <div class="field col-12 md:col-4">
            <label for="dust-extraction-floors" class="font-semibold block mb-2">Polveri n° piani aspiranti <span class="text-red-500" aria-hidden="true">*</span></label>
            <p-inputNumber inputId="dust-extraction-floors" [(ngModel)]="dustExtractionFloors" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 2" (onBlur)="markFieldAsTouched('dustExtractionFloors')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
            @if ((formSubmitted() || touchedFields.has('dustExtractionFloors')) && dustExtractionFloors() == null) {
              <small class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>
          <div class="field col-12 md:col-4">
            <label for="dust-extraction-arms" class="font-semibold block mb-2">Polveri n° bracci aspiranti <span class="text-red-500" aria-hidden="true">*</span></label>
            <p-inputNumber inputId="dust-extraction-arms" [(ngModel)]="dustExtractionArms" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 4" (onBlur)="markFieldAsTouched('dustExtractionArms')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
            @if ((formSubmitted() || touchedFields.has('dustExtractionArms')) && dustExtractionArms() == null) {
              <small class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>
        </div>
      </div>
    </section>

    <!-- SEZIONE 2: SERVIZI -->
    <section class="surface-0 border-round p-5 mb-4 shadow-1" role="region" aria-labelledby="section-servizi">
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-wrench text-2xl" style="color: #00125b;" aria-hidden="true"></i>
        <h2 id="section-servizi" class="text-xl font-semibold m-0" style="color: #00125b;">Sezione 2: Servizi</h2>
      </div>
      <div class="flex flex-column">

        <!-- Servizio Lavaggio -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="min-width: 220px;">
              <div class="font-semibold mb-2">Servizio Lavaggio <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Servizio Lavaggio">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasWashingService" [value]="true" [ngModel]="hasWashingService()" (ngModelChange)="hasWashingService.set($event)" inputId="has-washing-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-washing-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasWashingService" [value]="false" [ngModel]="hasWashingService()" (ngModelChange)="hasWashingService.set($event)" inputId="has-washing-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-washing-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && hasWashingService() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (hasWashingService()) {
              <div class="flex-none" style="min-width: 220px;">
                <label for="washing-type" class="font-semibold block mb-2">Luogo <span class="text-red-500" aria-hidden="true">*</span></label>
                <p-select inputId="washing-type" [(ngModel)]="washingServiceType" [options]="serviceTypeOptions()" optionLabel="label" optionValue="value" placeholder="Interno/Presso terzi" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                @if (formSubmitted() && !washingServiceType()) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- Servizio Meccanica -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="min-width: 220px;">
              <div class="font-semibold mb-2">Servizio Meccanica <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Servizio Meccanica">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasMechanicsService" [value]="true" [ngModel]="hasMechanicsService()" (ngModelChange)="hasMechanicsService.set($event)" inputId="has-mechanics-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-mechanics-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasMechanicsService" [value]="false" [ngModel]="hasMechanicsService()" (ngModelChange)="hasMechanicsService.set($event)" inputId="has-mechanics-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-mechanics-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && hasMechanicsService() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (hasMechanicsService()) {
              <div class="flex-none" style="min-width: 220px;">
                <label for="mechanics-type" class="font-semibold block mb-2">Luogo <span class="text-red-500" aria-hidden="true">*</span></label>
                <p-select inputId="mechanics-type" [(ngModel)]="mechanicsServiceType" [options]="serviceTypeOptions()" optionLabel="label" optionValue="value" placeholder="Interno/Presso terzi" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                @if (formSubmitted() && !mechanicsServiceType()) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- Diagnosi Elettronica -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="min-width: 220px;">
              <div class="font-semibold mb-2">Diagnosi elettronica <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Diagnosi elettronica">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasElectronicDiagnostics" [value]="true" [ngModel]="hasElectronicDiagnostics()" (ngModelChange)="hasElectronicDiagnostics.set($event)" inputId="has-diag-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-diag-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasElectronicDiagnostics" [value]="false" [ngModel]="hasElectronicDiagnostics()" (ngModelChange)="hasElectronicDiagnostics.set($event)" inputId="has-diag-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-diag-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && hasElectronicDiagnostics() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (hasElectronicDiagnostics()) {
              <div class="flex-none" style="min-width: 220px;">
                <label for="diag-type" class="font-semibold block mb-2">Luogo <span class="text-red-500" aria-hidden="true">*</span></label>
                <p-select inputId="diag-type" [(ngModel)]="electronicDiagnosticsType" [options]="serviceTypeOptions()" optionLabel="label" optionValue="value" placeholder="Interno/Presso terzi" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                @if (formSubmitted() && !electronicDiagnosticsType()) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- Servizio Elettrauto -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="min-width: 220px;">
              <div class="font-semibold mb-2">Servizio elettrauto <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Servizio elettrauto">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasElectricalService" [value]="true" [ngModel]="hasElectricalService()" (ngModelChange)="hasElectricalService.set($event)" inputId="has-electrical-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-electrical-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasElectricalService" [value]="false" [ngModel]="hasElectricalService()" (ngModelChange)="hasElectricalService.set($event)" inputId="has-electrical-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-electrical-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && hasElectricalService() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (hasElectricalService()) {
              <div class="flex-none" style="min-width: 220px;">
                <label for="electrical-type" class="font-semibold block mb-2">Luogo <span class="text-red-500" aria-hidden="true">*</span></label>
                <p-select inputId="electrical-type" [(ngModel)]="electricalServiceType" [options]="serviceTypeOptions()" optionLabel="label" optionValue="value" placeholder="Interno/Presso terzi" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                @if (formSubmitted() && !electricalServiceType()) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- Servizio Gomme -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="min-width: 220px;">
              <div class="font-semibold mb-2">Servizio Gomme <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Servizio Gomme">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasTireService" [value]="true" [ngModel]="hasTireService()" (ngModelChange)="hasTireService.set($event)" inputId="has-tire-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-tire-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasTireService" [value]="false" [ngModel]="hasTireService()" (ngModelChange)="hasTireService.set($event)" inputId="has-tire-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-tire-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && hasTireService() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (hasTireService()) {
              <div class="flex-none" style="min-width: 220px;">
                <label for="tire-type" class="font-semibold block mb-2">Luogo <span class="text-red-500" aria-hidden="true">*</span></label>
                <p-select inputId="tire-type" [(ngModel)]="tireServiceType" [options]="serviceTypeOptions()" optionLabel="label" optionValue="value" placeholder="Interno/Presso terzi" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                @if (formSubmitted() && !tireServiceType()) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- Ricarica Condizionatori -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="min-width: 220px;">
              <div class="font-semibold mb-2">Ricarica Condizionatori <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Ricarica Condizionatori">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasAirConditioningRecharge" [value]="true" [ngModel]="hasAirConditioningRecharge()" (ngModelChange)="hasAirConditioningRecharge.set($event)" inputId="has-ac-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-ac-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasAirConditioningRecharge" [value]="false" [ngModel]="hasAirConditioningRecharge()" (ngModelChange)="hasAirConditioningRecharge.set($event)" inputId="has-ac-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-ac-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && hasAirConditioningRecharge() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (hasAirConditioningRecharge()) {
              <div class="flex-none" style="min-width: 220px;">
                <label for="ac-type" class="font-semibold block mb-2">Luogo <span class="text-red-500" aria-hidden="true">*</span></label>
                <p-select inputId="ac-type" [(ngModel)]="airConditioningRechargeType" [options]="serviceTypeOptions()" optionLabel="label" optionValue="value" placeholder="Interno/Presso terzi" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                @if (formSubmitted() && !airConditioningRechargeType()) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- Revisione Ministeriale -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="min-width: 220px;">
              <div class="font-semibold mb-2">Revisione Ministeriale <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Revisione Ministeriale">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasMinisterialInspection" [value]="true" [ngModel]="hasMinisterialInspection()" (ngModelChange)="hasMinisterialInspection.set($event)" inputId="has-inspection-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-inspection-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasMinisterialInspection" [value]="false" [ngModel]="hasMinisterialInspection()" (ngModelChange)="hasMinisterialInspection.set($event)" inputId="has-inspection-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-inspection-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && hasMinisterialInspection() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (hasMinisterialInspection()) {
              <div class="flex-none" style="min-width: 220px;">
                <label for="inspection-type" class="font-semibold block mb-2">Luogo <span class="text-red-500" aria-hidden="true">*</span></label>
                <p-select inputId="inspection-type" [(ngModel)]="ministerialInspectionType" [options]="serviceTypeOptions()" optionLabel="label" optionValue="value" placeholder="Interno/Presso terzi" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                @if (formSubmitted() && !ministerialInspectionType()) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- Taratura sistemi ADAS -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="min-width: 220px;">
              <div class="font-semibold mb-2">Taratura sistemi ADAS <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Taratura sistemi ADAS">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasAdasSystemsCalibration" [value]="true" [ngModel]="hasAdasSystemsCalibration()" (ngModelChange)="hasAdasSystemsCalibration.set($event)" inputId="has-adas-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-adas-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasAdasSystemsCalibration" [value]="false" [ngModel]="hasAdasSystemsCalibration()" (ngModelChange)="hasAdasSystemsCalibration.set($event)" inputId="has-adas-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-adas-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && hasAdasSystemsCalibration() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (hasAdasSystemsCalibration()) {
              <div class="flex-none" style="min-width: 220px;">
                <label for="adas-type" class="font-semibold block mb-2">Luogo <span class="text-red-500" aria-hidden="true">*</span></label>
                <p-select inputId="adas-type" [(ngModel)]="adasSystemsCalibrationLocation" [options]="serviceTypeOptions()" optionLabel="label" optionValue="value" placeholder="Interno/Presso terzi" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                @if (formSubmitted() && !adasSystemsCalibrationLocation()) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- Commercio Autoveicoli -->
        <div class="field pt-3">
          <div class="font-semibold mb-2">Commercio autoveicoli <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Commercio autoveicoli">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="sellsMotorVehicles" [value]="true" [ngModel]="sellsMotorVehicles()" (ngModelChange)="sellsMotorVehicles.set($event)" inputId="has-vehicle-commerce-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-vehicle-commerce-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="sellsMotorVehicles" [value]="false" [ngModel]="sellsMotorVehicles()" (ngModelChange)="sellsMotorVehicles.set($event)" inputId="has-vehicle-commerce-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-vehicle-commerce-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && sellsMotorVehicles() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

      </div>
    </section>

    <!-- SEZIONE 3: RIPARAZIONI -->
    <section class="surface-0 border-round p-5 mb-4 shadow-1" role="region" aria-labelledby="section-riparazioni">
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-car text-2xl" style="color: #00125b;" aria-hidden="true"></i>
        <h2 id="section-riparazioni" class="text-xl font-semibold m-0" style="color: #00125b;">Sezione 3: Riparazioni</h2>
      </div>
      <div class="grid">

        <!-- 48: Interventi smart -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Interventi smart <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Interventi smart">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSmartServices" [value]="true" [ngModel]="hasSmartServices()" (ngModelChange)="hasSmartServices.set($event)" inputId="has-smart-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-smart-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSmartServices" [value]="false" [ngModel]="hasSmartServices()" (ngModelChange)="hasSmartServices.set($event)" inputId="has-smart-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-smart-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasSmartServices() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 49: SMART: Riparazione Danni Grandine -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">SMART: Riparazione Danni Grandine <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="SMART: Riparazione Danni Grandine">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasHailDamageRepair" [value]="true" [ngModel]="hasHailDamageRepair()" (ngModelChange)="hasHailDamageRepair.set($event)" inputId="has-hail-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-hail-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasHailDamageRepair" [value]="false" [ngModel]="hasHailDamageRepair()" (ngModelChange)="hasHailDamageRepair.set($event)" inputId="has-hail-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-hail-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasHailDamageRepair() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 50: SMART: Riparazione Parabrezza -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">SMART: Riparazione Parabrezza <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="SMART: Riparazione Parabrezza">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasWindshieldRepair" [value]="true" [ngModel]="hasWindshieldRepair()" (ngModelChange)="hasWindshieldRepair.set($event)" inputId="has-windshield-rep-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-windshield-rep-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasWindshieldRepair" [value]="false" [ngModel]="hasWindshieldRepair()" (ngModelChange)="hasWindshieldRepair.set($event)" inputId="has-windshield-rep-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-windshield-rep-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasWindshieldRepair() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 51: SMART: Riparazione Tessuti -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">SMART: Riparazione Tessuti <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="SMART: Riparazione Tessuti">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasFabricRepair" [value]="true" [ngModel]="hasFabricRepair()" (ngModelChange)="hasFabricRepair.set($event)" inputId="has-fabric-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-fabric-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasFabricRepair" [value]="false" [ngModel]="hasFabricRepair()" (ngModelChange)="hasFabricRepair.set($event)" inputId="has-fabric-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-fabric-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasFabricRepair() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 52: SMART: Riparazione Plastica - Pelle - Vinile -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">SMART: Riparazione Plastica - Pelle - Vinile <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="SMART: Riparazione Plastica - Pelle - Vinile">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasPlasticLeatherRepair" [value]="true" [ngModel]="hasPlasticLeatherRepair()" (ngModelChange)="hasPlasticLeatherRepair.set($event)" inputId="has-plastic-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-plastic-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasPlasticLeatherRepair" [value]="false" [ngModel]="hasPlasticLeatherRepair()" (ngModelChange)="hasPlasticLeatherRepair.set($event)" inputId="has-plastic-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-plastic-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasPlasticLeatherRepair() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 53: SMART: Riparazione Cerchioni -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">SMART: Riparazione Cerchioni <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="SMART: Riparazione Cerchioni">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasRimRepair" [value]="true" [ngModel]="hasRimRepair()" (ngModelChange)="hasRimRepair.set($event)" inputId="has-rim-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-rim-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasRimRepair" [value]="false" [ngModel]="hasRimRepair()" (ngModelChange)="hasRimRepair.set($event)" inputId="has-rim-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-rim-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasRimRepair() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 54: SMART: Riparazione Punti Specifici -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">SMART: Riparazione Punti Specifici <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="SMART: Riparazione Punti Specifici">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSpecificPointRepair" [value]="true" [ngModel]="hasSpecificPointRepair()" (ngModelChange)="hasSpecificPointRepair.set($event)" inputId="has-spot-points-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-spot-points-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSpecificPointRepair" [value]="false" [ngModel]="hasSpecificPointRepair()" (ngModelChange)="hasSpecificPointRepair.set($event)" inputId="has-spot-points-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-spot-points-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasSpecificPointRepair() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 55: Riparazioni di carrozzeria con le tecniche della riparazione a freddo -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Riparazioni di carrozzeria con le tecniche della riparazione a freddo <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Riparazioni di carrozzeria con le tecniche della riparazione a freddo">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="makeRepairsUsingColdRepairTechniques" [value]="true" [ngModel]="makeRepairsUsingColdRepairTechniques()" (ngModelChange)="makeRepairsUsingColdRepairTechniques.set($event)" inputId="has-cold-repair-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-cold-repair-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="makeRepairsUsingColdRepairTechniques" [value]="false" [ngModel]="makeRepairsUsingColdRepairTechniques()" (ngModelChange)="makeRepairsUsingColdRepairTechniques.set($event)" inputId="has-cold-repair-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-cold-repair-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && makeRepairsUsingColdRepairTechniques() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 56: Riparazioni Spot -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Riparazioni Spot <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Riparazioni Spot">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSpotRepairs" [value]="true" [ngModel]="hasSpotRepairs()" (ngModelChange)="hasSpotRepairs.set($event)" inputId="has-spot-repair-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-spot-repair-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSpotRepairs" [value]="false" [ngModel]="hasSpotRepairs()" (ngModelChange)="hasSpotRepairs.set($event)" inputId="has-spot-repair-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-spot-repair-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasSpotRepairs() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 57-59: Riparazioni Veicoli Particolari + Tipologie (gruppo) -->
        <div class="col-12">
          <div class="border-1 border-200 border-round p-3">
            <p class="font-semibold text-sm text-600 mt-0 mb-3">Veicoli Particolari</p>
            <div class="grid">

              <!-- 57: Riparazioni Veicoli Particolari -->
              <div class="field col-12 md:col-4">
                <div class="font-semibold block mb-2">Riparazioni Veicoli Particolari <span class="text-red-500" aria-hidden="true">*</span></div>
                <div class="flex gap-3" role="group" aria-label="Riparazioni Veicoli Particolari">
                  <div class="flex align-items-center gap-2">
                    <p-radiobutton name="hasSpecialVehicleRepairs" [value]="true" [ngModel]="hasSpecialVehicleRepairs()" (ngModelChange)="hasSpecialVehicleRepairs.set($event)" inputId="has-special-vehicles-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                    <label for="has-special-vehicles-si" class="cursor-pointer">Sì</label>
                  </div>
                  <div class="flex align-items-center gap-2">
                    <p-radiobutton name="hasSpecialVehicleRepairs" [value]="false" [ngModel]="hasSpecialVehicleRepairs()" (ngModelChange)="hasSpecialVehicleRepairs.set($event)" inputId="has-special-vehicles-no" [disabled]="isReadOnly()" ariaLabel="No" />
                    <label for="has-special-vehicles-no" class="cursor-pointer">No</label>
                  </div>
                </div>
                @if (formSubmitted() && hasSpecialVehicleRepairs() === null) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>

              <!-- 58-59: Tipologie Veicoli Particolari -->
              @if (hasSpecialVehicleRepairs()) {
              <div class="field col-12">
                <div class="flex align-items-center justify-content-between mb-2">
                  <label class="font-semibold">Tipologie Veicoli Particolari</label>
                  @if (!isReadOnly()) {
                    <button type="button" pButton label="Aggiungi" icon="pi pi-plus" class="p-button-sm p-button-outlined add-item-btn" aria-label="Aggiungi tipologia veicolo" (click)="addSpecialVehicle()"></button>
                  }
                </div>
                @if (specialVehicles().length === 0) {
                  <p class="text-secondary m-0">Nessuna tipologia aggiunta.</p>
                  @if (formSubmitted()) {
                    <small class="text-red-500" role="alert">Aggiungere almeno una tipologia di veicolo</small>
                  }
                }
                @for (vehicle of specialVehicles(); track vehicle.id; let idx = $index) {
                  <div class="card bg-gray-50 mb-2 p-3">
                    <div class="flex align-items-center justify-content-between mb-2">
                      <label [attr.for]="'vehicle-type-' + vehicle.id" class="font-semibold">Tipologia Veicolo {{ idx + 1 }}</label>
                      @if (!isReadOnly()) {
                        <button type="button" pButton icon="pi pi-trash" class="p-button-sm p-button-danger p-button-text" (click)="removeSpecialVehicle(vehicle.id)" aria-label="Rimuovi veicolo"></button>
                      }
                    </div>
                    <div class="grid">
                      <div class="field col-12 md:col-4">
                        <p-select [inputId]="'vehicle-type-' + vehicle.id" [(ngModel)]="vehicle.vehicleType" [options]="getAvailableSpecialVehicleOptions(vehicle.id)" optionLabel="label" optionValue="value" placeholder="Seleziona" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                      </div>
                      @if (vehicle.vehicleType === 'OTHER') {
                        <div class="field col-12 md:col-4">
                          <label [attr.for]="'vehicle-other-' + vehicle.id" class="font-semibold block mb-2">Specifica <span class="text-red-500" aria-hidden="true">*</span></label>
                          <input [attr.id]="'vehicle-other-' + vehicle.id" type="text" pInputText [(ngModel)]="vehicle.vehicleTypeOther" placeholder="Tipo veicolo..." class="w-full" [disabled]="isReadOnly()" />
                          @if (formSubmitted() && !vehicle.vehicleTypeOther.trim()) {
                            <small class="text-red-500" role="alert">Campo obbligatorio</small>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
              }
            </div>

          </div>
        </div>

        <!-- 61: Auto Sostitutiva -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Auto Sostitutiva <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Auto Sostitutiva">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSubstituteCar" [value]="true" [ngModel]="hasSubstituteCar()" (ngModelChange)="hasSubstituteCar.set($event)" inputId="has-substitute-car-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-substitute-car-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSubstituteCar" [value]="false" [ngModel]="hasSubstituteCar()" (ngModelChange)="hasSubstituteCar.set($event)" inputId="has-substitute-car-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-substitute-car-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasSubstituteCar() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 62: Auto a Noleggio n° -->
        <div class="field col-12 md:col-4">
          <label for="rental-cars-count" class="font-semibold block mb-2">Auto a Noleggio n° <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="rental-cars-count" [(ngModel)]="rentalCarsCount" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 5" (onBlur)="markFieldAsTouched('rentalCarsCount')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
          @if ((formSubmitted() || touchedFields.has('rentalCarsCount')) && rentalCarsCount() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 63: Auto di Proprietà n° -->
        <div class="field col-12 md:col-4">
          <label for="owned-cars-count" class="font-semibold block mb-2">Auto di Proprietà n° <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="owned-cars-count" [(ngModel)]="ownedCarsCount" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 3" (onBlur)="markFieldAsTouched('ownedCarsCount')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
          @if ((formSubmitted() || touchedFields.has('ownedCarsCount')) && ownedCarsCount() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 64: Soccorso Stradale entro 20km -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Soccorso Stradale entro 20km <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Soccorso Stradale entro 20km">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasRoadsideAssistance20km" [value]="true" [ngModel]="hasRoadsideAssistance20km()" (ngModelChange)="hasRoadsideAssistance20km.set($event)" inputId="has-roadside-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-roadside-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasRoadsideAssistance20km" [value]="false" [ngModel]="hasRoadsideAssistance20km()" (ngModelChange)="hasRoadsideAssistance20km.set($event)" inputId="has-roadside-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-roadside-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasRoadsideAssistance20km() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 65: Soccorso Stradale (Mezzi Propri/Esterno) -->
        <div class="field col-12 md:col-4">
          <label for="roadside-type" class="font-semibold block mb-2">Soccorso Stradale (Mezzi Propri/Esterno) <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-select inputId="roadside-type" [(ngModel)]="roadsideAssistanceType" [options]="roadsideAssistanceTypeOptions()" optionLabel="label" optionValue="value" placeholder="Seleziona" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
          @if (formSubmitted() && !roadsideAssistanceType()) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 66: Carroattrezzi di Proprietà n° -->
        <div class="field col-12 md:col-4">
          <label for="tow-trucks-count" class="font-semibold block mb-2">Carroattrezzi di Proprietà n° <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="tow-trucks-count" [(ngModel)]="ownedTowTrucksCount" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 2" (onBlur)="markFieldAsTouched('ownedTowTrucksCount')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
          @if ((formSubmitted() || touchedFields.has('ownedTowTrucksCount')) && ownedTowTrucksCount() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 67: Pick up & Delivery - servizio presa e riconsegna veicolo a domicilio entro 20km -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Pick up &amp; Delivery - servizio presa e riconsegna veicolo a domicilio entro 20km <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Pick up e Delivery entro 20km">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasPickupDelivery20km" [value]="true" [ngModel]="hasPickupDelivery20km()" (ngModelChange)="hasPickupDelivery20km.set($event)" inputId="has-pickup-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-pickup-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasPickupDelivery20km" [value]="false" [ngModel]="hasPickupDelivery20km()" (ngModelChange)="hasPickupDelivery20km.set($event)" inputId="has-pickup-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-pickup-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasPickupDelivery20km() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 68: Lavaggio esterno e Pulizia/Aspirazione -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Lavaggio esterno e Pulizia/Aspirazione <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Lavaggio esterno e Pulizia/Aspirazione">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasInteriorWashing" [value]="true" [ngModel]="hasInteriorWashing()" (ngModelChange)="hasInteriorWashing.set($event)" inputId="has-ext-washing-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-ext-washing-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasInteriorWashing" [value]="false" [ngModel]="hasInteriorWashing()" (ngModelChange)="hasInteriorWashing.set($event)" inputId="has-ext-washing-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-ext-washing-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasInteriorWashing() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 69: Finitura con Piccoli Ritocchi -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Finitura con Piccoli Ritocchi <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Finitura con Piccoli Ritocchi">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasFinishingTouches" [value]="true" [ngModel]="hasFinishingTouches()" (ngModelChange)="hasFinishingTouches.set($event)" inputId="has-finishing-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-finishing-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasFinishingTouches" [value]="false" [ngModel]="hasFinishingTouches()" (ngModelChange)="hasFinishingTouches.set($event)" inputId="has-finishing-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-finishing-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasFinishingTouches() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 70: Controllo Livelli Motore ed Eventuali Rabbocco Liquidi -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Controllo Livelli Motore ed Eventuali Rabbocco Liquidi <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Controllo Livelli Motore ed Eventuali Rabbocco Liquidi">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasEngineLevelCheck" [value]="true" [ngModel]="hasEngineLevelCheck()" (ngModelChange)="hasEngineLevelCheck.set($event)" inputId="has-engine-check-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-engine-check-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasEngineLevelCheck" [value]="false" [ngModel]="hasEngineLevelCheck()" (ngModelChange)="hasEngineLevelCheck.set($event)" inputId="has-engine-check-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-engine-check-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasEngineLevelCheck() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 71: Controllo Pressione/Usura/Rotazione Pneumatici -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Controllo Pressione/Usura/Rotazione Pneumatici <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Controllo Pressione/Usura/Rotazione Pneumatici">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasTirePressureCheck" [value]="true" [ngModel]="hasTirePressureCheck()" (ngModelChange)="hasTirePressureCheck.set($event)" inputId="has-tire-check-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-tire-check-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasTirePressureCheck" [value]="false" [ngModel]="hasTirePressureCheck()" (ngModelChange)="hasTirePressureCheck.set($event)" inputId="has-tire-check-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-tire-check-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasTirePressureCheck() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 72: Pulizia ed Igienizzazione Condotti A.C. -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Pulizia ed Igienizzazione Condotti A.C. <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Pulizia ed Igienizzazione Condotti A.C.">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasAirConditioningCleaning" [value]="true" [ngModel]="hasAirConditioningCleaning()" (ngModelChange)="hasAirConditioningCleaning.set($event)" inputId="has-ac-cleaning-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-ac-cleaning-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasAirConditioningCleaning" [value]="false" [ngModel]="hasAirConditioningCleaning()" (ngModelChange)="hasAirConditioningCleaning.set($event)" inputId="has-ac-cleaning-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-ac-cleaning-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasAirConditioningCleaning() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 73: Igienizzazione Aree Abitacolo -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Igienizzazione Aree Abitacolo <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Igienizzazione Aree Abitacolo">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasCabinSanitization" [value]="true" [ngModel]="hasCabinSanitization()" (ngModelChange)="hasCabinSanitization.set($event)" inputId="has-sanitization-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-sanitization-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasCabinSanitization" [value]="false" [ngModel]="hasCabinSanitization()" (ngModelChange)="hasCabinSanitization.set($event)" inputId="has-sanitization-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-sanitization-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasCabinSanitization() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 74: Check up Meccanico -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Check up Meccanico <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Check up Meccanico">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasMechanicalCheckup" [value]="true" [ngModel]="hasMechanicalCheckup()" (ngModelChange)="hasMechanicalCheckup.set($event)" inputId="has-mechcheck-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-mechcheck-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasMechanicalCheckup" [value]="false" [ngModel]="hasMechanicalCheckup()" (ngModelChange)="hasMechanicalCheckup.set($event)" inputId="has-mechcheck-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-mechcheck-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasMechanicalCheckup() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

      </div>
    </section>


    <!-- SEZIONE 4: FLOTTE E CERTIFICAZIONI -->
    <section class="surface-0 border-round p-5 mb-4 shadow-1" role="region" aria-labelledby="section-flotte">
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-shield text-2xl" style="color: #00125b;" aria-hidden="true"></i>
        <h2 id="section-flotte" class="text-xl font-semibold m-0" style="color: #00125b;">Sezione 4: Flotte e Certificazioni</h2>
      </div>
      <div class="grid">
        <!-- 76: Riparazione Autovetture Noleggio -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Riparazione Autovetture Noleggio <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Riparazione Autovetture Noleggio">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasRentalVehicleRepairs" [value]="true" [ngModel]="hasRentalVehicleRepairs()" (ngModelChange)="hasRentalVehicleRepairs.set($event)" inputId="has-rental-repairs-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-rental-repairs-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasRentalVehicleRepairs" [value]="false" [ngModel]="hasRentalVehicleRepairs()" (ngModelChange)="hasRentalVehicleRepairs.set($event)" inputId="has-rental-repairs-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-rental-repairs-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasRentalVehicleRepairs() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- Nomi Flotte -->
        <div class="col-12">
          <div class="border-1 border-200 border-round p-3">
            <p class="font-semibold text-sm text-600 mt-0 mb-3">Nomi Flotte</p>
            <div class="flex align-items-center justify-content-between mb-2">
              <span></span>
              @if (!isReadOnly()) {
                <button type="button" pButton label="Aggiungi" icon="pi pi-plus" class="p-button-sm p-button-outlined add-item-btn" aria-label="Aggiungi flotta" (click)="addFleet()"></button>
              }
            </div>
            @if (fleets().length === 0) {
              <p class="text-secondary m-0">Nessuna flotta aggiunta.</p>
            }
            @for (fleet of fleets(); track fleet.id; let idx = $index) {
              <div class="card bg-gray-50 mb-2 p-3">
                <div class="flex align-items-center justify-content-between mb-2">
                  <label [attr.for]="'fleet-name-' + fleet.id" class="font-semibold">Nome Flotta {{ idx + 1 }}</label>
                  @if (!isReadOnly()) {
                    <button type="button" pButton icon="pi pi-trash" class="p-button-sm p-button-danger p-button-text" (click)="removeFleet(fleet.id)" aria-label="Rimuovi flotta"></button>
                  }
                </div>
                <div class="grid">
                  <div class="field col-12 md:col-4">
                    <input [attr.id]="'fleet-name-' + fleet.id" type="text" pInputText [(ngModel)]="fleet.fleetName" placeholder="Es: Hertz, Europcar..." class="w-full" [disabled]="isReadOnly()" />
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        <!-- 79: Carrozzeria Autorizzata Tesla? -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Carrozzeria Autorizzata Tesla? <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Carrozzeria Autorizzata Tesla?">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="isTeslaAuthorized" [value]="true" [ngModel]="isTeslaAuthorized()" (ngModelChange)="isTeslaAuthorized.set($event)" inputId="has-tesla-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-tesla-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="isTeslaAuthorized" [value]="false" [ngModel]="isTeslaAuthorized()" (ngModelChange)="isTeslaAuthorized.set($event)" inputId="has-tesla-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-tesla-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && isTeslaAuthorized() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- Carrozzeria Autorizzata Casa Automobilistica -->
        <div class="col-12">
          <div class="border-1 border-200 border-round p-3">
            <p class="font-semibold text-sm text-600 mt-0 mb-3">Carrozzeria Autorizzata Casa Automobilistica</p>
            <div class="flex align-items-center justify-content-between mb-2">
              <span></span>
              @if (!isReadOnly()) {
                <button type="button" pButton label="Aggiungi" icon="pi pi-plus" class="p-button-sm p-button-outlined add-item-btn" aria-label="Aggiungi casa automobilistica" (click)="addAuthorization()"></button>
              }
            </div>
            @if (authorizations().length === 0) {
              <p class="text-secondary m-0">Nessuna casa automobilistica aggiunta.</p>
            }
            @for (auth of authorizations(); track auth.id; let idx = $index) {
              <div class="card bg-gray-50 mb-2 p-3">
                <div class="flex align-items-center justify-content-between mb-2">
                  <label [attr.for]="'car-man-' + auth.id" class="font-semibold">Casa Automobilistica {{ idx + 1 }}</label>
                  @if (!isReadOnly()) {
                    <button type="button" pButton icon="pi pi-trash" class="p-button-sm p-button-danger p-button-text" (click)="removeAuthorization(auth.id)" aria-label="Rimuovi casa automobilistica"></button>
                  }
                </div>
                <div class="grid">
                  <div class="field col-12 md:col-4">
                    <p-select [inputId]="'car-man-' + auth.id" [(ngModel)]="auth.carManufacturer" [options]="getAvailableCarManufacturerOptions(auth.id)" optionLabel="label" optionValue="value" placeholder="Seleziona" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                  </div>
                  @if (auth.carManufacturer === 'OTHER') {
                    <div class="field col-12 md:col-4">
                      <label [attr.for]="'car-man-other-' + auth.id" class="font-semibold block mb-2">Specifica <span class="text-red-500" aria-hidden="true">*</span></label>
                      <input [attr.id]="'car-man-other-' + auth.id" type="text" pInputText [(ngModel)]="auth.carManufacturerOther" placeholder="Casa automobilistica..." class="w-full" [disabled]="isReadOnly()" />
                      @if (formSubmitted() && !auth.carManufacturerOther.trim()) {
                        <small class="text-red-500" role="alert">Campo obbligatorio</small>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>

        <!-- 81: Certificazioni Legge 626 -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Certificazioni Legge 626 <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Certificazioni Legge 626">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSafetyCertifications" [value]="true" [ngModel]="hasSafetyCertifications()" (ngModelChange)="hasSafetyCertifications.set($event)" inputId="has-safety-cert-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-safety-cert-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSafetyCertifications" [value]="false" [ngModel]="hasSafetyCertifications()" (ngModelChange)="hasSafetyCertifications.set($event)" inputId="has-safety-cert-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-safety-cert-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasSafetyCertifications() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 82: Certificazione Asseverazione Tecnico Giurato -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Certificazione Asseverazione Politecnico <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Certificazione Asseverazione Politecnico">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSwornCertifications" [value]="true" [ngModel]="hasSwornCertifications()" (ngModelChange)="hasSwornCertifications.set($event)" inputId="has-sworn-cert-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-sworn-cert-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSwornCertifications" [value]="false" [ngModel]="hasSwornCertifications()" (ngModelChange)="hasSwornCertifications.set($event)" inputId="has-sworn-cert-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-sworn-cert-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasSwornCertifications() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 83: Certificazioni Green -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Certificazioni Green <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Certificazioni Green">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasGreenCertifications" [value]="true" [ngModel]="hasGreenCertifications()" (ngModelChange)="hasGreenCertifications.set($event)" inputId="has-green-cert-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-green-cert-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasGreenCertifications" [value]="false" [ngModel]="hasGreenCertifications()" (ngModelChange)="hasGreenCertifications.set($event)" inputId="has-green-cert-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-green-cert-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasGreenCertifications() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <!-- 84: Quali certificazioni Green -->
        @if (hasGreenCertifications() === true) {
          <div class="field col-12 md:col-8">
            <label for="green-cert-details" class="font-semibold block mb-2">Quali certificazioni Green <span class="text-red-500" aria-hidden="true">*</span></label>
            <input id="green-cert-details" type="text" pInputText [(ngModel)]="greenCertifications" placeholder="Descrizione" class="w-full" [disabled]="isReadOnly()" aria-required="true" aria-describedby="green-cert-details-error" />
            @if (formSubmitted() && !greenCertifications().trim()) {
              <small id="green-cert-details-error" class="text-red-500" role="alert">Campo obbligatorio</small>
            }
          </div>
        }

        <!-- 85: Certificazioni ISO -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Certificazioni ISO <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Certificazioni ISO">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasIsoCertifications" [value]="true" [ngModel]="hasIsoCertifications()" (ngModelChange)="hasIsoCertifications.set($event)" inputId="has-iso-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-iso-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasIsoCertifications" [value]="false" [ngModel]="hasIsoCertifications()" (ngModelChange)="hasIsoCertifications.set($event)" inputId="has-iso-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-iso-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasIsoCertifications() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <!-- 86: Quali certificazioni ISO -->
        @if (hasIsoCertifications() === true) {
          <div class="col-12">
            <div class="border-1 border-200 border-round p-3">
              <p class="font-semibold text-sm text-600 mt-0 mb-3">Certificazioni ISO</p>
              <div class="flex align-items-center justify-content-between mb-2">
                <span></span>
                @if (!isReadOnly()) {
                  <button type="button" pButton label="Aggiungi" icon="pi pi-plus" class="p-button-sm p-button-outlined add-item-btn" aria-label="Aggiungi certificazione ISO" (click)="addIsoCertification()"></button>
                }
              </div>
              @if (isoCertifications().length === 0) {
                <p class="text-secondary m-0">Nessuna certificazione ISO aggiunta.</p>
                @if (formSubmitted()) {
                  <small class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              }
              @for (cert of isoCertifications(); track cert.id; let idx = $index) {
                <div class="card bg-gray-50 mb-2 p-3">
                  <div class="flex align-items-center justify-content-between mb-2">
                    <label [attr.for]="'iso-cert-' + cert.id" class="font-semibold">Certificazione ISO {{ idx + 1 }} <span class="text-red-500" aria-hidden="true">*</span></label>
                    @if (!isReadOnly()) {
                      <button type="button" pButton icon="pi pi-trash" class="p-button-sm p-button-danger p-button-text" (click)="removeIsoCertification(cert.id)" aria-label="Rimuovi certificazione"></button>
                    }
                  </div>
                  <div class="grid">
                    <div class="field col-12 md:col-4">
                      <p-select [inputId]="'iso-cert-' + cert.id" [(ngModel)]="cert.isoCertification" [options]="getAvailableIsoOptions(cert.id)" optionLabel="label" optionValue="value" placeholder="Seleziona" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                      @if (formSubmitted() && !cert.isoCertification) {
                        <small class="text-red-500" role="alert">Campo obbligatorio</small>
                      }
                    </div>
                    @if (cert.isoCertification === 'OTHER') {
                      <div class="field col-12 md:col-4">
                        <label [attr.for]="'iso-other-' + cert.id" class="font-semibold block mb-2">Specifica <span class="text-red-500" aria-hidden="true">*</span></label>
                        <input [attr.id]="'iso-other-' + cert.id" type="text" pInputText [(ngModel)]="cert.otherIsoCertification" placeholder="Specifica..." class="w-full" [disabled]="isReadOnly()" />
                        @if (formSubmitted() && !cert.otherIsoCertification?.trim()) {
                          <small class="text-red-500" role="alert">Campo obbligatorio</small>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- 87-93: Eco-sostenibili -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Vetture di cortesia ibride/elettriche <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Vetture di cortesia ibride/elettriche">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasHybridCourtesyCars" [value]="true" [ngModel]="hasHybridCourtesyCars()" (ngModelChange)="hasHybridCourtesyCars.set($event)" inputId="has-hybrid-cars-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-hybrid-cars-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasHybridCourtesyCars" [value]="false" [ngModel]="hasHybridCourtesyCars()" (ngModelChange)="hasHybridCourtesyCars.set($event)" inputId="has-hybrid-cars-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-hybrid-cars-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasHybridCourtesyCars() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Colonnine di ricarica <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Colonnine di ricarica">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasChargingColumns" [value]="true" [ngModel]="hasChargingColumns()" (ngModelChange)="hasChargingColumns.set($event)" inputId="has-charging-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-charging-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasChargingColumns" [value]="false" [ngModel]="hasChargingColumns()" (ngModelChange)="hasChargingColumns.set($event)" inputId="has-charging-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-charging-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasChargingColumns() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <!-- 89: Certificazioni su uso di verniciatura ecologica/a ridotto impatto ambientale -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Certificazioni su uso di verniciatura ecologica/a ridotto impatto ambientale <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Certificazioni verniciatura ecologica">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasEcologicalPaintCertifications" [value]="true" [ngModel]="hasEcologicalPaintCertifications()" (ngModelChange)="hasEcologicalPaintCertifications.set($event)" inputId="has-ecological-paint-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-ecological-paint-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasEcologicalPaintCertifications" [value]="false" [ngModel]="hasEcologicalPaintCertifications()" (ngModelChange)="hasEcologicalPaintCertifications.set($event)" inputId="has-ecological-paint-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-ecological-paint-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasEcologicalPaintCertifications() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <!-- 90: Pannelli solari -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Pannelli solari <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Pannelli solari">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSolarPanels" [value]="true" [ngModel]="hasSolarPanels()" (ngModelChange)="hasSolarPanels.set($event)" inputId="has-solar-panels-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-solar-panels-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSolarPanels" [value]="false" [ngModel]="hasSolarPanels()" (ngModelChange)="hasSolarPanels.set($event)" inputId="has-solar-panels-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-solar-panels-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasSolarPanels() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Forni endotermici a basso impatto di emissioni di CO2 <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Forni endotermici a basso impatto di emissioni di CO2">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasEndothermicBoothsWithLowCo2Emission" [value]="true" [ngModel]="hasEndothermicBoothsWithLowCo2Emission()" (ngModelChange)="hasEndothermicBoothsWithLowCo2Emission.set($event)" inputId="has-low-co2-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-low-co2-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasEndothermicBoothsWithLowCo2Emission" [value]="false" [ngModel]="hasEndothermicBoothsWithLowCo2Emission()" (ngModelChange)="hasEndothermicBoothsWithLowCo2Emission.set($event)" inputId="has-low-co2-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-low-co2-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasEndothermicBoothsWithLowCo2Emission() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Utilizza parti di ricambio OE riciclate <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Utilizza parti di ricambio OE riciclate">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="usesRecycledOeReplacementParts" [value]="true" [ngModel]="usesRecycledOeReplacementParts()" (ngModelChange)="usesRecycledOeReplacementParts.set($event)" inputId="uses-recycled-parts-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="uses-recycled-parts-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="usesRecycledOeReplacementParts" [value]="false" [ngModel]="usesRecycledOeReplacementParts()" (ngModelChange)="usesRecycledOeReplacementParts.set($event)" inputId="uses-recycled-parts-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="uses-recycled-parts-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && usesRecycledOeReplacementParts() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Utilizza strumenti digitali (paperless) <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Utilizza strumenti digitali (paperless)">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="usesDigitalTools" [value]="true" [ngModel]="usesDigitalTools()" (ngModelChange)="usesDigitalTools.set($event)" inputId="uses-digital-tools-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="uses-digital-tools-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="usesDigitalTools" [value]="false" [ngModel]="usesDigitalTools()" (ngModelChange)="usesDigitalTools.set($event)" inputId="uses-digital-tools-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="uses-digital-tools-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && usesDigitalTools() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 94: Altre Certificazioni? -->
        <div class="field col-12">
          <label for="other-certifications" class="font-semibold block mb-2">Altre Certificazioni?</label>
          <input id="other-certifications" type="text" pInputText [(ngModel)]="otherCertifications" placeholder="Descrizione libera" class="w-full" [disabled]="isReadOnly()" />
        </div>
      </div>
    </section>

    <!-- SEZIONE 5: CONVENZIONI -->
    <section class="surface-0 border-round p-5 mb-4 shadow-1" role="region" aria-labelledby="section-convenzioni">
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-handshake text-2xl" style="color: #00125b;" aria-hidden="true"></i>
        <h2 id="section-convenzioni" class="text-xl font-semibold m-0" style="color: #00125b;">Sezione 5: Convenzioni</h2>
      </div>
      <div class="flex flex-column">

        <!-- Convenzione AXA Assistance -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="width: 370px;">
              <div class="font-semibold mb-2">Convenzione con AXA Assistance? <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Convenzione con AXA Assistance?">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasAgreementWithAxaAssistance" [value]="true" [ngModel]="hasAgreementWithAxaAssistance()" (ngModelChange)="hasAgreementWithAxaAssistance.set($event)" inputId="has-axa-conv-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-axa-conv-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasAgreementWithAxaAssistance" [value]="false" [ngModel]="hasAgreementWithAxaAssistance()" (ngModelChange)="hasAgreementWithAxaAssistance.set($event)" inputId="has-axa-conv-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-axa-conv-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && hasAgreementWithAxaAssistance() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
          </div>
        </div>

        <!-- Convenzionato con altre Compagnie di Assicurazioni -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="width: 370px;">
              <div class="font-semibold mb-2">Convenzionato con altre Compagnie di Assicurazioni <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Convenzionato con altre Compagnie di Assicurazioni">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasAgreementWithOtherInsuranceCompanies" [value]="true" [ngModel]="hasAgreementWithOtherInsuranceCompanies()" (ngModelChange)="hasAgreementWithOtherInsuranceCompanies.set($event)" inputId="has-other-ins-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-other-ins-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasAgreementWithOtherInsuranceCompanies" [value]="false" [ngModel]="hasAgreementWithOtherInsuranceCompanies()" (ngModelChange)="hasAgreementWithOtherInsuranceCompanies.set($event)" inputId="has-other-ins-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-other-ins-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && hasAgreementWithOtherInsuranceCompanies() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (hasAgreementWithOtherInsuranceCompanies()) {
              <div class="flex-none" style="width: 370px;">
                <label for="other-ins-text" class="font-semibold block mb-2">Se sì, specificare quale <span class="text-red-500" aria-hidden="true">*</span></label>
                <input id="other-ins-text" type="text" pInputText [(ngModel)]="otherInsuranceConventions" placeholder="Nomi compagnie" class="w-full" [disabled]="isReadOnly()" aria-required="true" aria-describedby="other-ins-text-error" />
                @if (formSubmitted() && !otherInsuranceConventions().trim()) {
                  <small id="other-ins-text-error" class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- Convenzione con Provider Grandine -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="width: 370px;">
              <div class="font-semibold mb-2">Convenzione con Provider Grandine? <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Convenzione con Provider Grandine?">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasAgreementWithHailProviders" [value]="true" [ngModel]="hasAgreementWithHailProviders()" (ngModelChange)="hasAgreementWithHailProviders.set($event)" inputId="has-hail-prov-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-hail-prov-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasAgreementWithHailProviders" [value]="false" [ngModel]="hasAgreementWithHailProviders()" (ngModelChange)="hasAgreementWithHailProviders.set($event)" inputId="has-hail-prov-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-hail-prov-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && hasAgreementWithHailProviders() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (hasAgreementWithHailProviders()) {
              <div class="flex-none" style="width: 370px;">
                <label for="hail-prov-text" class="font-semibold block mb-2">Se sì, specificare quale <span class="text-red-500" aria-hidden="true">*</span></label>
                <input id="hail-prov-text" type="text" pInputText [(ngModel)]="hailProvidersInAgreement" placeholder="Nome provider" class="w-full" [disabled]="isReadOnly()" aria-required="true" aria-describedby="hail-prov-text-error" />
                @if (formSubmitted() && !hailProvidersInAgreement().trim()) {
                  <small id="hail-prov-text-error" class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- Convenzione con Provider Cristalli -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="width: 370px;">
              <div class="font-semibold mb-2">Convenzione con Provider Cristalli? <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Convenzione con Provider Cristalli?">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasAgreementWithCrystalProviders" [value]="true" [ngModel]="hasAgreementWithCrystalProviders()" (ngModelChange)="hasAgreementWithCrystalProviders.set($event)" inputId="has-glass-prov-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-glass-prov-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="hasAgreementWithCrystalProviders" [value]="false" [ngModel]="hasAgreementWithCrystalProviders()" (ngModelChange)="hasAgreementWithCrystalProviders.set($event)" inputId="has-glass-prov-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-glass-prov-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && hasAgreementWithCrystalProviders() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (hasAgreementWithCrystalProviders()) {
              <div class="flex-none" style="width: 370px;">
                <label for="glass-prov-text" class="font-semibold block mb-2">Se sì, specificare quale <span class="text-red-500" aria-hidden="true">*</span></label>
                <input id="glass-prov-text" type="text" pInputText [(ngModel)]="crystalProvidersInAgreement" placeholder="Nome provider" class="w-full" [disabled]="isReadOnly()" aria-required="true" aria-describedby="glass-prov-text-error" />
                @if (formSubmitted() && !crystalProvidersInAgreement().trim()) {
                  <small id="glass-prov-text-error" class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- Appartiene a qualche network di carrozzerie -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="width: 370px;">
              <div class="font-semibold mb-2">Appartiene a qualche network di carrozzerie? <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Appartiene a qualche network di carrozzerie?">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="isPartOfNetwork" [value]="true" [ngModel]="isPartOfNetwork()" (ngModelChange)="isPartOfNetwork.set($event)" inputId="belongs-network-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="belongs-network-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="isPartOfNetwork" [value]="false" [ngModel]="isPartOfNetwork()" (ngModelChange)="isPartOfNetwork.set($event)" inputId="belongs-network-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="belongs-network-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && isPartOfNetwork() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (isPartOfNetwork()) {
              <div class="flex-none" style="width: 370px;">
                <label for="network-text" class="font-semibold block mb-2">Se sì, specificare quale <span class="text-red-500" aria-hidden="true">*</span></label>
                <input id="network-text" type="text" pInputText [(ngModel)]="nameOfNetwork" placeholder="Nome network" class="w-full" [disabled]="isReadOnly()" aria-required="true" aria-describedby="network-text-error" />
                @if (formSubmitted() && !nameOfNetwork().trim()) {
                  <small id="network-text-error" class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- Affiliato a Network di una Flotta di noleggio a lungo termine -->
        <div class="py-3 border-bottom-1 border-100">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="width: 370px;">
              <div class="font-semibold mb-2">Affiliato a Network di una Flotta di noleggio a lungo termine? <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Affiliato a Network di una Flotta di noleggio a lungo termine?">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="isAffiliatedWithLongTermRentalFleetNetwork" [value]="true" [ngModel]="isAffiliatedWithLongTermRentalFleetNetwork()" (ngModelChange)="isAffiliatedWithLongTermRentalFleetNetwork.set($event)" inputId="has-nlt-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-nlt-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="isAffiliatedWithLongTermRentalFleetNetwork" [value]="false" [ngModel]="isAffiliatedWithLongTermRentalFleetNetwork()" (ngModelChange)="isAffiliatedWithLongTermRentalFleetNetwork.set($event)" inputId="has-nlt-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-nlt-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && isAffiliatedWithLongTermRentalFleetNetwork() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (isAffiliatedWithLongTermRentalFleetNetwork()) {
              <div class="flex-none" style="width: 370px;">
                <label for="nlt-text" class="font-semibold block mb-2">Se sì, specificare quale <span class="text-red-500" aria-hidden="true">*</span></label>
                <input id="nlt-text" type="text" pInputText [(ngModel)]="nameOfLongTermRentalFleetNetwork" placeholder="Nome rete" class="w-full" [disabled]="isReadOnly()" aria-required="true" aria-describedby="nlt-text-error" />
                @if (formSubmitted() && !nameOfLongTermRentalFleetNetwork().trim()) {
                  <small id="nlt-text-error" class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

        <!-- Affiliato a Network di una Flotta di noleggio a breve termine -->
        <div class="py-3">
          <div class="flex align-items-start gap-5 flex-wrap">
            <div class="flex-none" style="width: 370px;">
              <div class="font-semibold mb-2">Affiliato a Network di una Flotta di noleggio a breve termine <span class="text-red-500" aria-hidden="true">*</span></div>
              <div class="flex gap-3" role="group" aria-label="Affiliato a Network di una Flotta di noleggio a breve termine">
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="isAffiliatedWithShortTermRentalFleetNetwork" [value]="true" [ngModel]="isAffiliatedWithShortTermRentalFleetNetwork()" (ngModelChange)="isAffiliatedWithShortTermRentalFleetNetwork.set($event)" inputId="has-ncc-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
                  <label for="has-ncc-si" class="cursor-pointer">Sì</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-radiobutton name="isAffiliatedWithShortTermRentalFleetNetwork" [value]="false" [ngModel]="isAffiliatedWithShortTermRentalFleetNetwork()" (ngModelChange)="isAffiliatedWithShortTermRentalFleetNetwork.set($event)" inputId="has-ncc-no" [disabled]="isReadOnly()" ariaLabel="No" />
                  <label for="has-ncc-no" class="cursor-pointer">No</label>
                </div>
              </div>
              @if (formSubmitted() && isAffiliatedWithShortTermRentalFleetNetwork() === null) {
                <small class="text-red-500" role="alert">Campo obbligatorio</small>
              }
            </div>
            @if (isAffiliatedWithShortTermRentalFleetNetwork()) {
              <div class="flex-none" style="width: 370px;">
                <label for="ncc-text" class="font-semibold block mb-2">Se sì, specificare quale <span class="text-red-500" aria-hidden="true">*</span></label>
                <input id="ncc-text" type="text" pInputText [(ngModel)]="nameOfShortTermRentalFleetNetwork" placeholder="Nome rete" class="w-full" [disabled]="isReadOnly()" aria-required="true" aria-describedby="ncc-text-error" />
                @if (formSubmitted() && !nameOfShortTermRentalFleetNetwork().trim()) {
                  <small id="ncc-text-error" class="text-red-500" role="alert">Campo obbligatorio</small>
                }
              </div>
            }
          </div>
        </div>

      </div>
    </section>

    <!-- SEZIONE 6: RISORSE UMANE -->
    <section class="surface-0 border-round p-5 mb-4 shadow-1" role="region" aria-labelledby="section-risorse">
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-users text-2xl" style="color: #00125b;" aria-hidden="true"></i>
        <h2 id="section-risorse" class="text-xl font-semibold m-0" style="color: #00125b;">Sezione 6: Risorse Umane</h2>
      </div>
      <div class="grid">
        <div class="field col-12 md:col-4">
          <label for="employees-count" class="font-semibold block mb-2">N° Dipendenti inseriti a Libro Matricola <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="employees-count" [(ngModel)]="employeesCount" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 15" (onBlur)="markFieldAsTouched('employeesCount')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
          @if ((formSubmitted() || touchedFields.has('employeesCount')) && employeesCount() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <label for="bodyworkers-count" class="font-semibold block mb-2">N° Lattonieri <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="bodyworkers-count" [(ngModel)]="tinsmithsCount" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 5" (onBlur)="markFieldAsTouched('tinsmithsCount')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
          @if ((formSubmitted() || touchedFields.has('tinsmithsCount')) && tinsmithsCount() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <label for="preparers-count" class="font-semibold block mb-2">N° Preparatori/Filtatori <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="preparers-count" [(ngModel)]="preparersCount" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 5" (onBlur)="markFieldAsTouched('preparersCount')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
          @if ((formSubmitted() || touchedFields.has('preparersCount')) && preparersCount() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <label for="painters-count" class="font-semibold block mb-2">N° Verniciatori <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="painters-count" [(ngModel)]="paintersCount" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 3" (onBlur)="markFieldAsTouched('paintersCount')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
          @if ((formSubmitted() || touchedFields.has('paintersCount')) && paintersCount() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <label for="assembly-count" class="font-semibold block mb-2">N° Addetti Stacco/Riattacco <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="assembly-count" [(ngModel)]="assemblyWorkersCount" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 4" (onBlur)="markFieldAsTouched('assemblyWorkersCount')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
          @if ((formSubmitted() || touchedFields.has('assemblyWorkersCount')) && assemblyWorkersCount() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>
        <div class="field col-12 md:col-4">
          <label for="clerks-count" class="font-semibold block mb-2">N° Impiegati <span class="text-red-500" aria-hidden="true">*</span></label>
          <p-inputNumber inputId="clerks-count" [(ngModel)]="clerksCount" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 2" (onBlur)="markFieldAsTouched('clerksCount')" [pt]="{ pcInputText: { root: { 'aria-required': 'true' } } }" />
          @if ((formSubmitted() || touchedFields.has('clerksCount')) && clerksCount() == null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- Corsi Formativi -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Corsi Formativi <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Corsi Formativi">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasTrainingCourses" [value]="true" [ngModel]="hasTrainingCourses()" (ngModelChange)="hasTrainingCourses.set($event)" inputId="has-training-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-training-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasTrainingCourses" [value]="false" [ngModel]="hasTrainingCourses()" (ngModelChange)="hasTrainingCourses.set($event)" inputId="has-training-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-training-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasTrainingCourses() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- Totale Computer -->
        <div class="field col-12 md:col-4">
          <label for="total-computers" class="font-semibold block mb-2">Totale Computer</label>
          <p-inputNumber inputId="total-computers" [(ngModel)]="totalComputers" [min]="0" [showButtons]="false" styleClass="w-full" placeholder="Es: 5" />
        </div>

        <!-- 116: Software Preventivi -->
        <div class="field col-12 md:col-4">
          <div class="font-semibold block mb-2">Software Preventivi <span class="text-red-500" aria-hidden="true">*</span></div>
          <div class="flex gap-3" role="group" aria-label="Software Preventivi">
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSoftwarePreventivi" [value]="true" [ngModel]="hasSoftwarePreventivi()" (ngModelChange)="hasSoftwarePreventivi.set($event)" inputId="has-software-prev-si" [disabled]="isReadOnly()" ariaLabel="Sì" />
              <label for="has-software-prev-si" class="cursor-pointer">Sì</label>
            </div>
            <div class="flex align-items-center gap-2">
              <p-radiobutton name="hasSoftwarePreventivi" [value]="false" [ngModel]="hasSoftwarePreventivi()" (ngModelChange)="hasSoftwarePreventivi.set($event)" inputId="has-software-prev-no" [disabled]="isReadOnly()" ariaLabel="No" />
              <label for="has-software-prev-no" class="cursor-pointer">No</label>
            </div>
          </div>
          @if (formSubmitted() && hasSoftwarePreventivi() === null) {
            <small class="text-red-500" role="alert">Campo obbligatorio</small>
          }
        </div>

        <!-- 117: Tipologia Software Preventivi - Lista Dinamica -->
        @if (hasSoftwarePreventivi()) {
        <div class="col-12">
          <div class="border-1 border-200 border-round p-3">
            <p class="font-semibold text-sm text-600 mt-0 mb-3">Tipologia Software Preventivi</p>
            <div class="flex align-items-center justify-content-between mb-2">
              <span></span>
              @if (!isReadOnly()) {
                <button type="button" pButton label="Aggiungi preventivatore" icon="pi pi-plus" class="p-button-sm p-button-outlined add-item-btn" aria-label="Aggiungi preventivatore" (click)="addEstimateSoftware()"></button>
              }
            </div>
            @if (estimateSoftwareTypes().length === 0) {
              <p class="text-secondary m-0">Nessun preventivatore aggiunto.</p>
            }
            @for (sw of estimateSoftwareTypes(); track $index; let idx = $index) {
              <div class="card bg-gray-50 mb-2 p-3">
                <div class="flex align-items-center justify-content-between mb-2">
                  <label [attr.for]="'sw-type-' + idx" class="font-semibold">Preventivatore {{ idx + 1 }}</label>
                  @if (!isReadOnly()) {
                    <button type="button" pButton icon="pi pi-trash" class="p-button-sm p-button-danger p-button-text" (click)="removeEstimateSoftware(idx)" aria-label="Rimuovi preventivatore"></button>
                  }
                </div>
                <div class="grid">
                  <div class="field col-12 md:col-6">
                    <p-select [inputId]="'sw-type-' + idx" [(ngModel)]="sw.softwareType" [options]="getAvailableEstimateSoftwareOptions(idx)" optionLabel="label" optionValue="value" placeholder="Seleziona" styleClass="w-full" [disabled]="isReadOnly()" [pt]="{ root: { 'aria-required': 'true' } }" />
                  </div>
                  @if (sw.softwareType === 'OTHER') {
                    <div class="field col-12 md:col-6">
                      <label [attr.for]="'sw-other-' + idx" class="font-semibold block mb-2">Specifica <span class="text-red-500" aria-hidden="true">*</span></label>
                      <input [attr.id]="'sw-other-' + idx" type="text" pInputText [(ngModel)]="sw.softwareTypeOther" placeholder="Specificare..." class="w-full" [disabled]="isReadOnly()" />
                      @if (formSubmitted() && !sw.softwareTypeOther?.trim()) {
                        <small class="text-red-500" role="alert">Campo obbligatorio</small>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
        } <!-- End @if (hasSoftwarePreventivi()) -->
      </div>
    </section>

  } <!-- End of @else (STANDARD/ARS/RCI/NOBIS) -->

  <!-- I collaboratori sono ora gestiti nella sezione dedicata "Impiegati Amministrativi e Collaboratori" del wizard. -->

  <!-- Footer con pulsanti -->
  @if (!isReadOnly()) {
  <div class="card">
    <div class="flex flex-wrap gap-3 justify-content-end">
      <button
        type="button"
        pButton
        label="Salva Bozza"
        icon="pi pi-save"
        class="p-button-outlined"
        (click)="saveDraft()"
        [disabled]="isSaving()"
        [attr.aria-label]="'Salva i dati in bozza senza validazione'"
      ></button>

      <button
        type="button"
        pButton
        [label]="isOperationalLocation() ? 'Salva' : 'Salva e continua'"
        [icon]="isOperationalLocation() ? 'pi pi-check' : 'pi pi-arrow-right'"
        iconPos="right"
        (click)="saveAndProceed()"
        [disabled]="isSaving()"
        [loading]="isSaving()"
        [attr.aria-label]="isOperationalLocation() ? 'Valida e salva i dati' : 'Valida e salva i dati, poi procedi allo step successivo'"
      ></button>
    </div>
  </div>
  }
</div>
